<template>
  <div class="drage-grid" :style="bgstyle"
  @drop="drop($event)" @dragover="allowDrop($event)" @click.self="closeCnpSet">
    <grid-layout
        v-model:layout="layout"
        :autoSize="false"
        :col-num="parseInt(colNum)"
        :row-height="rowHeight"
        :is-mirrored="mirrored"
        :prevent-collision="preventCollision"
        :vertical-compact="styleTemp.absorb === 'open'?true:false"
        :use-css-transforms="true"
        :responsive="responsive"
        :auto-size="false"
        :cols="{lg: 12, md: 12, sm: 12, xs: 12, xxs: 12}"
      >
        <template v-for="(item, index) in layout">
          <!--        viewShow 隐藏 true 显示 false -->
          <grid-item
            :style="[ item.type === 'swiper' ? '' : {zIndex:'1'} ]"
            :class="[item.linkTop ? 'link-top-b' : '', item.linkBottom ? 'link-bottom-b' : '']"
            v-if="!item.viewShow && !item.isContainer"
            :ref="'grid-item' + item.i"
            :key="item.i"
            :static="item.static"
            :x="item.x"
            :y="item.y"
            :w="item.w"
            :h="item.h"
            :i="item.i"
            :is-draggable="!draggableObj[item.i] && isFrontEnd"
            :is-resizable="!draggableObj[item.i] && isFrontEnd"
          >
            <template  #default="{ styleSync }">
              <!-- 明细表 -->
              <div v-if="item.type === 'detailed'"
                  :class="['grid-drage detailing', item.transparentBackground ? 'bTransparent' : '', item.projectionTransparent ? 'pTransparent' : '',]"
                  :style="[item.showWay === 4 ? 'background-color:#f0f2f5;padding-left:0;padding-right:0;width:100%;' : '',bgfillSet(item.bgfillStyle || item.bgfllStyle, item.transparentBackground)]">
                  <!-- 操作 -->
                <select-box
                  v-if="!item.nameShow || item.toolbar || isFrontEnd"
                  :styleTemp="styleTemp"
                  :data="item"
                  :index="index"
                  :draggable="draggable"
                  :resizable="resizable"
                  :isFrontEnd="isFrontEnd"
                  v-model:layout="layout"
                  :customDeskInfo="customDeskInfo"
                  @handle="handle"
                >
                <toolbar 
                  v-if="item.toolbar"
                  :config="item"
                  :isFrontEnd="isFrontEnd"
                  :style="item.showWay && item.showWay === 4 ? 'padding-left:10px;' : ''"
                  :configComponent="item"
                  :customDeskInfo="customDeskInfo"
                  @toolbar-edit-user="toolbarEditUser"
                  @usual="(val) => usual(val, item.i)"
                  @searchRelevanceConfig="searchRelevanceConfig"
                  @singleRelevanceConfig="(val) => singleRelevanceConfig(val, item)" />
                </select-box> 
                <!-- 表格内容 -->
                <!-- 明细表报表 -->
                <div
                  class="grid-table"
                  :style="getHeight(item)"
                  v-if="
                    (item.loadSetting && (item.loadSetting === 'scroll' && item.curpage !== 1)) ||
                    (!item.skeletonLoading ||
                    item.skeletonLoading === false ||
                    item.appId == '')
                  "
                >
                  <!-- 表格内容 -->
                  <table-detail v-model:tableDetailData="layout[index]"
                                @customizeButton="singleRelevance"
                                @loadPage="loadPage"
                                @goSearch="goSearchList"
                                @relevanceFun="changeRelevanceFun"
                                @selectedTable="(val) => selectedTable(val, item)"
                                @edit-user="editUser"
                                @singleRelevance="singleRelevance" />
                </div>

                <!-- 骨架屏 -->
                <skeleton-view
                  style="height: 77%"
                  v-if="
                    (!item.loadSetting || (item.loadSetting !== 'scroll' || item.loadSetting === 'scroll' && item.curpage === 1)) && (item.skeletonLoading === true && item.appId && item.appId != '')
                  "
                  :h="item.h - 5"
                />

                <!-- 分页 -->
                <drageGridNav
                  v-if="item.pageTotal > (item.article || item.article === 0 ? item.article : 20) && (
                    (!item.loadSetting || item.loadSetting === 'pages') &&
                    (!item.skeletonLoading ||
                    item.skeletonLoading === false ||
                    item.appId == ''))
                  "
                  :subScript="index"
                  :pageTotal="item.pageTotal"
                  :article="item.article"
                  :curpage="item.curpage"
                  :disabled="disabled"
                  @pageChange="pageChange"
                />
              </div>

              <!-- 汇总表 -->
              <div v-else-if="item.type === 'summary'"
                  :class="['grid-drage summarizing', item.transparentBackground ? 'bTransparent' : '', item.projectionTransparent ? 'pTransparent' : '']"
                  :style="bgfillSet(item.bgfillStyle || item.bgfllStyle,item.transparentBackground)">
                <!-- 操作 -->
                <select-box
                  v-if="!item.nameShow || item.toolbar || isFrontEnd"
                  :styleTemp="styleTemp"
                  :data="item"
                  :index="index"
                  :layoutIndex="layout.findIndex(its => its.i === item.i)"
                  :draggable="draggable"
                  :resizable="resizable"
                  :isFrontEnd="isFrontEnd"
                  :layout="layout"
                  :customDeskInfo="customDeskInfo"
                  @handle="handle"
                >
                  <!-- 工具条 -->
                  <toolbar 
                    v-if="item.toolbar"
                    :config="item"
                    :isFrontEnd="isFrontEnd"
                    :configComponent="item"
                    :summary="item.summary"
                    :customDeskInfo="customDeskInfo"
                    @closeButton="closeButton"
                    @upSummary="upSummary"
                    @change-filed="changeFiled(item, $event)"
                    @usual="(val) => usual(val, item.i)"
                    @searchRelevanceConfig="searchRelevanceConfig"
                    @singleRelevanceConfig="(val) => singleRelevanceConfig(val, item)" />
                </select-box> 

                <div class="img-list">
                  <div v-for="(tt, tti) in getLegend(item)" :key="tti" class="img-tt">
                    <div class="img-tt-i"><icon-module :config="tt.img"></icon-module></div>
                    <div class="img-tt-v">{{ tt.value }}</div>
                  </div>
                </div>
                <!-- 表格内容 -->
                <div
                  class="grid-table"
                  :style="[getHeight(item), {overflow: 'auto', paddingTop: '5px'}]"
                  v-if="
                    !item.skeletonLoading ||
                    item.skeletonLoading === false ||
                    item.appId == ''
                  "
                  :key="item.upRevise"
                  >
                  <template v-if="item.row && item.row[0] && item.row[0].partition">
                    <template v-for="(itt, index) in item.partitionList" :key="itt + index">
                      <partition :dashboardId="id"
                        :partitionKey="itt"
                        :row="item.row"
                        :column="item.column"
                        :summary="item.summary"
                        :topCount="item.topCount"
                        :id="item.i"
                        :isSummary="item.isSummary"
                        :tableData="item.tableData"
                        :mergeTable="item.tableMerge"
                        :merge="item.merge"
                        :isFrontEnd="isFrontEnd"
                        :total="item.pageTotal || 0"
                        :totalPage="item.pages || 0"
                        :page="item.devCurpage"
                        :overflowTable="item.overflow"
                        :index="index + ''"
                        :user="item.user"
                        :lineClamp="Number(item.lineClamp)"
                        :summaryObj="getSummary(item.summary)"
                        :config="item"
                        @relevanceFun="changeRelevanceFun"
                        @selectedTable="(val) => selectedTable(val, item)"
                        @goSearch="goSummarySearch"
                        @rSetReviseRow="rSetReviseRow"
                        :reviseObj="reviseObj[item.i]"
                        :saveRevise="saveRevise[item.i]"
                        :selectRow="item.selectRow"
                        :selectCloum="item.selectCloum"
                        :selectPage="item.selectPage"
                        :titleConfig="item.titleConfig"
                        :valueConfig="item.valueConfig"
                        :rowWidth="item.rowWidth" />
                    </template>
                  </template>
                  <template v-else>
                    <template v-if="isFrontEnd">
                      <sumTable
                        v-if="item.merge && item.merge.length > 0"
                        :dashboardId="id"
                        :row="item.row"
                        :column="item.column"
                        :summary="item.summary"
                        :topCount="item.topCount"
                        :id="item.i"
                        :ref="'sumTableRefs_' + item.i"
                        :isSummary="item.isSummary"
                        :lineClamp="Number(item.lineClamp)"
                        :titleConfig="item.titleConfig"
                        :valueConfig="item.valueConfig"
                        :rowWidth="item.rowWidth"
                        :config="item"
                        :summaryObj="getSummary(item.summary)"
                        :tableData="
                      tableFun(
                        item.tableData || [],
                        item.devCurpage,
                        item.devArticle
                      )
                    "
                        :mergeTable="
                      tableMergeFun(
                        tableFun(
                          item.tableData || [],
                          item.devCurpage,
                          item.devArticle
                        ),
                        item
                      )
                    "
                        :merge="item.merge"
                        :total="item.pageTotal ? item.pageTotal : item.tableData.length"
                        :totalPage="
                      item.pages
                        ? item.pages
                        : Math.ceil(item.tableData.length / item.devArticle)
                    "
                        :page="item.devCurpage"
                        :overflowTable="item.overflow"
                        :index="index + ''"
                        @relevanceFun="changeRelevanceFun"
                        @selectedTable="(val) => selectedTable(val, item)"
                        @goSearch="goSummarySearch"
                        @rSetReviseRow="rSetReviseRow"
                        :reviseObj="reviseObj[item.i]"
                        :saveRevise="saveRevise[item.i]"
                        :selectRow="item.selectRow"
                        :selectCloum="item.selectCloum"
                        :selectPage="item.selectPage"
                      ></sumTable>
                    </template>
                    <template v-else>
                      <sumTable
                        v-if="item.merge && item.merge.length > 0"
                        :dashboardId="id"
                        :row="item.row"
                        :column="item.column"
                        :summary="item.summary"
                        :topCount="item.topCount"
                        :id="item.i"
                        :ref="'sumTableRefs_' + item.i"
                        :isSummary="item.isSummary"
                        :tableData="item.tableData"
                        :mergeTable="tableMergeFun(
                        tableFun(
                          item.tableData || [],
                          item.devCurpage,
                          item.devArticle,
                        ),
                        item
                      )"
                        :merge="item.merge"
                        :isFrontEnd="isFrontEnd"
                        :total="item.pageTotal || 0"
                        :totalPage="item.pages || 0"
                        :page="item.devCurpage"
                        :overflowTable="item.overflow"
                        :index="index + ''"
                        :user="item.user"
                        :lineClamp="Number(item.lineClamp)"
                        :summaryObj="getSummary(item.summary)"
                        :config="item"
                        @relevanceFun="changeRelevanceFun"
                        @selectedTable="(val) => selectedTable(val, item)"
                        @goSearch="goSummarySearch"
                        @rSetReviseRow="rSetReviseRow"
                        :reviseObj="reviseObj[item.i]"
                        :saveRevise="saveRevise[item.i]"
                        :selectRow="item.selectRow"
                        :selectCloum="item.selectCloum"
                        :selectPage="item.selectPage"
                        :titleConfig="item.titleConfig"
                        :valueConfig="item.valueConfig"
                        :rowWidth="item.rowWidth"
                      ></sumTable>
                      <template v-if="item.merge && item.merge.length > 0"></template>
                      <div v-else class="no-data">
                        <img src="https://bigdata.topeti.com/PCRepository/defaultSvg/Intersect.svg" />
                        <div>暂无数据</div>
                      </div>
                    </template>
                  </template>
                </div>

                <!-- 骨架屏 -->
                <skeleton-view
                  style="height: 77%"
                  v-if="item.skeletonLoading === true && item.appId && item.appId != ''"
                  :h="item.h - 5"
                />

                <!-- 分页 -->
                <drageGridNav
                  v-if="item.pageTotal && item.pageTotal > (item.devArticle || item.devArticle === 0 ? item.devArticle : 20) && (
                    !item.skeletonLoading ||
                    item.skeletonLoading === false ||
                    item.appId == '')
                  "
                  :subScript="index"
                  :pageTotal="
                    item.pageTotal
                      ? item.pageTotal
                      : item.tableData
                      ? item.tableData.length
                      : 0
                  "
                  :article="item.devArticle"
                  :curpage="item.devCurpage"
                  :disabled="disabled"
                  @pageChange="sumPageChange"
                />
                <!-- <div v-if="item.upRevise" class="revise">
                  <el-button size="small" @click="closeButton(item.i)">取消</el-button>
                  <el-button size="small" type="primary" @click.stop="upSummary({ uId: item.i, i: item.upRevise.i, insideInfo: item.upRevise.config })">保存</el-button>
                </div> -->
              </div>

              <!-- 多类型图表 -->
              <div v-else-if="item.type === 'indicatorsBread'"
                  :class="['grid-drage', item.transparentBackground ? 'bTransparent' : '', item.projectionTransparent ? 'pTransparent' : '']"
                  :style="[{
                    backgroundColor: theme && theme.backgroundColor ? theme.backgroundColor : ''
                    },bgfillSet(item.bgfillStyle || item.bgfllStyle,item.transparentBackground)]">
                <!-- 操作 -->
                <select-box
                  v-if="!item.nameShow || item.toolbar || isFrontEnd"
                  :styleTemp="styleTemp"
                  :data="item"
                  :theme="theme"
                  :index="index"
                  :draggable="draggable"
                  :resizable="resizable"
                  :isFrontEnd="isFrontEnd"
                  :layout="layout"
                  :customDeskInfo="customDeskInfo"
                  @handle="handle"
                  @upchart="(val) => upchart(val, item, index)"
                >
                  <toolbar v-if="item.toolbar"
                    :config="item"
                    :isFrontEnd="isFrontEnd"
                    :configComponent="item"
                    :customDeskInfo="customDeskInfo"
                    @usual="(val) => usual(val, item.i)"
                    @searchRelevanceConfig="searchRelevanceConfig"
                    @singleRelevanceConfig="(val) => singleRelevanceConfig(val, item)" /> 
                </select-box>
                <div
                  class="grid-table"
                  :style="getIndicatorsBreadHeight(item)"
                  v-if="
                    !item.skeletonLoading ||
                    item.skeletonLoading === false ||
                    item.appId == ''
                  "
                >
                  <!-- 指标图表格内容 -->
                  <indicators-details
                    v-if="item.chartType === 'indicators'"
                    :tableData="item.tableData"
                    :row="item.row"
                    :summary="item.summary"
                    :reName="item.reName"
                    :total="item.totalValue"
                    :fontSize="item.h"
                    :defaultStyleConfig="layout[index].styleConfig"
                    :id="item.i"
                    :isRowVirtual="item.isRowVirtual"
                    :isFrontEnd="isFrontEnd"
                    :page="item.devCurpage"
                    :ref="'indicatorsRefs_' + item.i"
                    :selectPage="item.selectPage"
                    :user="item.user"
                    v-model:projectionTransparent="item.projectionTransparent"
                    v-model:transparentBackground="item.transparentBackground"
                    :nameShow="item.nameShow"
                    @relevanceFun="changeRelevanceFun"
                  />

                  <!-- 饼图表格内容 -->
                  <bread-details
                    v-if="item.chartType === 'bread'"
                    :width="windowWidth"
                    :theme="item.themeConfig && JSON.stringify(item.themeConfig) != '{}' ? item.themeConfig : theme"
                    :viewShow="item.viewShow"
                    :tableData="item.tableData"
                    :echartsTempId="item.echartsTempId"
                    :id="item.i"
                    :row="item.row"
                    :summary="item.summary"
                    :isFrontEnd="isFrontEnd"
                    :user="item.user"
                    @relevanceFun="changeRelevanceFun"
                    :changeSize="item.w + item.h"
                  />

                  <!-- 面积图表格内容 -->
                  <proportion-details
                    v-if="item.chartType === 'proportion'"
                    :theme="item.themeConfig && JSON.stringify(item.themeConfig) != '{}' ? item.themeConfig : theme"
                    :width="windowWidth"
                    :viewShow="item.viewShow"
                    :echartsTempId="item.echartsTempId"
                    ref="proportionRefs"
                    :tableData="item.tableData"
                    :id="item.i"
                    :row="item.row"
                    :column="item.column"
                    :summary="item.summary"
                    :isFrontEnd="isFrontEnd"
                    @relevanceFun="changeRelevanceFun"
                    :changeSize="item.w + item.h"
                    :user="item.user"
                  />

                  <!-- 柱状图表格内容 -->
                  <columnar-details
                    v-if="item.chartType === 'columnar'"
                    :theme="item.themeConfig && JSON.stringify(item.themeConfig) != '{}' ? item.themeConfig : theme"
                    :width="windowWidth"
                    :viewShow="item.viewShow"
                    ref="columnarRefs"
                    :tableData="item.tableData"
                    :echartsTempId="item.echartsTempId"
                    :id="item.i"
                    :row="item.row"
                    :column="item.column || []"
                    :summary="item.summary"
                    :isFrontEnd="isFrontEnd"
                    @relevanceFun="changeRelevanceFun"
                    :changeSize="item.w + item.h"
                    :user="item.user"
                  />
                  <!-- 柱状堆积图表格内容 -->
                  <columnar-stacking
                    v-if="item.chartType === 'columnarStacking'"
                    :theme="item.themeConfig && JSON.stringify(item.themeConfig) != '{}' ? item.themeConfig : theme"
                    :width="windowWidth"
                    :viewShow="item.viewShow"
                    ref="columnarRefs"
                    :tableData="item.tableData"
                    :id="item.i"
                    :row="item.row"
                    :summary="item.summary"
                    :column="item.column"
                    :isFrontEnd="isFrontEnd"
                    @relevanceFun="changeRelevanceFun"
                    :changeSize="item.w + item.h"
                    :user="item.user"
                  />

                  <!-- 环形图表格内容 -->
                  <annular-details
                    v-if="item.chartType === 'annular'"
                    :theme="item.themeConfig && JSON.stringify(item.themeConfig) != '{}' ? item.themeConfig : theme"
                    :width="windowWidth"
                    :viewShow="item.viewShow"
                    ref="annularRefs"
                    :tableData="item.tableData"
                    :echartsTempId="item.echartsTempId"
                    :id="item.i"
                    :row="item.row"
                    :summary="item.summary"
                    :isFrontEnd="isFrontEnd"
                    @relevanceFun="changeRelevanceFun"
                    :changeSize="item.w + item.h"
                    :user="item.user"
                  />

                  <!-- 折线图表格内容 -->
                  <broken-line-details
                    v-if="item.chartType === 'brokenLine'"
                    :theme="item.themeConfig && JSON.stringify(item.themeConfig) != '{}' ? item.themeConfig : theme"
                    :width="windowWidth"
                    :viewShow="item.viewShow"
                    ref="brokenLineRefs"
                    :tableData="item.tableData"
                    :echartsTempId="item.echartsTempId"
                    :id="item.i"
                    :row="item.row"
                    :summary="item.summary"
                    :column="item.column"
                    :isFrontEnd="isFrontEnd"
                    @relevanceFun="changeRelevanceFun"
                    :changeSize="item.w + item.h"
                    :user="item.user"
                  />

                  <!-- 条形图表格内容 -->
                  <bar-type-details
                    v-if="item.chartType === 'barType'"
                    :theme="item.themeConfig && JSON.stringify(item.themeConfig) != '{}' ? item.themeConfig : theme"
                    :width="windowWidth"
                    :viewShow="item.viewShow"
                    ref="barTypeRefs"
                    :tableData="item.tableData"
                    :id="item.i"
                    :row="item.row"
                    :column="item.column"
                    :summary="item.summary"
                    :isFrontEnd="isFrontEnd"
                    @relevanceFun="changeRelevanceFun"
                    :changeSize="item.w + item.h"
                    :user="item.user"
                  />

                  <!-- 散点图 -->
                  <scatter
                    v-if="item.chartType === 'scatter'"
                    :theme="item.themeConfig && JSON.stringify(item.themeConfig) != '{}' ? item.themeConfig : theme"
                    :width="windowWidth"
                    :viewShow="item.viewShow"
                    ref="scatterRefs"
                    :tableData="item.tableData"
                    :id="item.i"
                    :row="item.row"
                    :column="item.column"
                    :summary="item.summary"
                    :isFrontEnd="isFrontEnd"
                    @relevanceFun="changeRelevanceFun"
                    :changeSize="item.w + item.h"
                    :user="item.user"
                  />
                  <!-- 雷达图  -->
                  <radar
                    v-if="item.chartType === 'radar'"
                    :theme="item.themeConfig && JSON.stringify(item.themeConfig) != '{}' ? item.themeConfig : theme"
                    :width="windowWidth"
                    :viewShow="item.viewShow"
                    ref="radarRefs"
                    :tableData="item.tableData"
                    :id="item.i"
                    :row="item.row"
                    :column="item.column"
                    :summary="item.summary"
                    :isFrontEnd="isFrontEnd"
                    @relevanceFun="changeRelevanceFun"
                    :changeSize="item.w + item.h"
                    :user="item.user"
                  />
                  <!-- 时间轴表格内容 -->
                  <timeline
                    v-if="item.chartType === 'timeline'"
                    :theme="item.themeConfig && JSON.stringify(item.themeConfig) != '{}' ? item.themeConfig : theme"
                    :width="windowWidth"
                    :viewShow="item.viewShow"
                    ref="timelineRefs"
                    :tableData="item.tableData"
                    :id="item.i"
                    :row="item.row"
                    :column="item.column || []"
                    :summary="item.summary"
                    :isFrontEnd="isFrontEnd"
                    @relevanceFun="changeRelevanceFun"
                    :changeSize="item.w + item.h"
                    :user="item.user"
                  />
                  <!-- K线图 -->
                  <candlestick
                    v-if="item.chartType === 'candlestick'"
                    :theme="item.themeConfig && JSON.stringify(item.themeConfig) != '{}' ? item.themeConfig : theme"
                    :width="windowWidth"
                    :viewShow="item.viewShow"
                    ref="candlestickRefs"
                    :tableData="item.tableData"
                    :id="item.i"
                    :row="item.row"
                    :column="item.column"
                    :summary="item.summary"
                    :isFrontEnd="isFrontEnd"
                    @relevanceFun="changeRelevanceFun"
                    :changeSize="item.w + item.h"
                    :user="item.user"
                  />
                  <!-- 热力图 -->
                  <heatmap
                    v-if="item.chartType === 'heatmap'"
                    :theme="item.themeConfig && JSON.stringify(item.themeConfig) != '{}' ? item.themeConfig : theme"
                    :width="windowWidth"
                    :viewShow="item.viewShow"
                    ref="heatmapRefs"
                    v-model:tableData="item.tableData"
                    :id="item.i"
                    :row="item.row"
                    :column="item.column"
                    :summary="item.summary"
                    :isFrontEnd="isFrontEnd"
                    @relevanceFun="changeRelevanceFun"
                    :changeSize="item.w + item.h"
                    :user="item.user"
                  />
                  <!-- 地图 -->
                  <mapContainer
                    ref="mapRefs"
                    v-else-if="item.chartType === 'gdMap'"
                    v-model:tableData="item.tableData"
                    :id="item.i"
                    :row="item.row"
                    :column="item.column"
                    :summary="item.summary"
                    :mapConfig="item.gdMapConfig"
                  />
                  <!-- 矩形树图 -->
                  <treemap
                    v-else-if="item.chartType === 'treemap'"
                    :theme="item.themeConfig && JSON.stringify(item.themeConfig) != '{}' ? item.themeConfig : theme"
                    :width="windowWidth"
                    :viewShow="item.viewShow"
                    ref="treemapRefs"
                    :tableData="item.tableData"
                    :id="item.i"
                    :row="item.row"
                    :column="item.column"
                    :summary="item.summary"
                    :isFrontEnd="isFrontEnd"
                    @relevanceFun="changeRelevanceFun"
                    :changeSize="item.w + item.h"
                    :user="item.user"
                    :config="item.treemapConfig"
                  />

                </div>

                <!-- 骨架屏 -->
                <skeleton-view
                  style="height: 77%"
                  v-if="item.skeletonLoading === true && item.appId && item.appId != ''"
                  :h="item.h < 10 ? 15 : item.h - 5"
                />

                <!-- 分页 -->
                <drageGridNav
                  v-if="
                  (!item.skeletonLoading &&
                    item.chartType === 'indicators' &&
                    item.isRowVirtual === false) ||
                  (item.appId == '' &&
                    item.chartType === 'indicators' &&
                    item.isRowVirtual === false)
                  "
                  :subScript="index"
                  :pageTotal="
                    item.pageTotal
                    ? item.pageTotal
                    : item.tableData
                    ? item.tableData.length
                    : 0
                  "
                  :article="item.devArticle"
                  :curpage="item.devCurpage"
                  :disabled="disabled"
                  @pageChange="indicatorsChange"
                />
              </div>

              <!-- 文本组件 -->
              <div v-else-if="item.type === 'text'"
                :class="['grid-drage', isFrontEnd === true ? 'textArea' : 'textAreaHou', item.transparentBackground ? 'bTransparent' : '', item.projectionTransparent ? 'pTransparent' : '']"
                :style="bgfillSet(item.bgfillStyle || item.bgfllStyle,item.transparentBackground)">
                <!-- 选择框 -->
                <text-cpn
                  :data="item"
                  :id="id"
                  :index="index"
                  @handle="handle"
                  :isFrontEnd="isFrontEnd"
                  @handleSet="(val)=> { setCallBack(val, index) }"
                />
                <!-- <div
                  class="grid-text"
                  :style="'height:calc(100% - ' + (isFrontEnd ? 53 : 20) +'px)'"
                > -->
                  <!--            :style="'height:' + classHeight(item.h, 'text') + 'px'"-->
                  <!-- {{item.h}} -->
                  <!-- <rich-text-editor
                    ref="richtexteditor"
                    @changedatas="changeSontoFa"
                    :catchData.sync="item"
                    :isFrontEnd="isFrontEnd"
                    :disabled="disabled"
                    :content.sync="item.bindinf"
                  ></rich-text-editor> -->
                <!-- </div> -->
              </div>

              <!-- 筛选组件 -->
              <div v-else-if="item.type === 'Sizer'" :class="['grid-drage Sizer', item.transparentBackground ? 'bTransparent' : '', item.projectionTransparent ? 'pTransparent' : '']">
                <!-- 筛选组件显示内容 -->
                <!-- 筛选组件后台设置时的遮罩层 -->
                <div class="filter-center"
                    :style="((!item.expandStyle || item.expandStyle === 'stop') && item.activeName === 'select' && item.FilterField.type !== 'date' && item.w >= 4 && item.h >= 12) || (item.expandStyle && item.expandStyle === 'portrait') ? 'display:block;' : ''">
                  <template v-if="item.activeName === 'select' && item.w >= 4 && item.h >= 12 && item.FilterField.type !== 'date'">
                    <select-box
                      :data="item"
                      :index="index"
                      :draggable="draggable"
                      :resizable="resizable"
                      @handle="handle"
                    ></select-box>
                    <div class="coverText" v-if="isFrontEnd === true"></div>
                  </template>
                  <template v-else>
                    <!-- 编辑块 -->
                    <div v-if="isFrontEnd === true" class="filter-editor">
                      <i :class="['iconfont', item.viewShow ? 'icon-dakaixianshi' : 'icon-yincangxianshi']"
                        @click="viewShowFun({item: item, index: index })" />
                      <i class="iconfont icon-shanchu5" @click="handle({status: 'delete', index: index})" />
                      <i class="iconfont icon-wenjianbeifen" @click="handle({status: 'copy', index: index, item: item})" />
                      <i class="iconfont icon-bianji" @click="handle({status: 'amend', item: item})" />
                    </div>

                    <div :class="['filter-title-text', item.expandStyle && item.expandStyle === 'horizontal' ? 'filter-title-text-horizontal' : '']">
                      {{item.datasName || '筛选组件'}}
                    </div>
                  </template>
                  <div
                    class="grid-text filter-grid-text"
                    :style="
                      'height:' +
                      classHeight(item.h, 'Sizer') +
                      'px,margin-top:0px;position:relative'
                    "
                  >
                    <sizer-detail
                      v-model:sizerDetailData="layout[index]"
                      :sizerIndex="index"
                      :sizerDisabled="disabled"
                      @transferFun="selectFromsDatas"
                      @transferStatusFun="changeSizerSta"
                      @handleCheckAllChange="handleCheckAllChange"
                      @updatePeople="updatePeople"
                      @numberTypeChange="numberTypeChange"
                      @dateTypeChange="timeTypeChange"
                    />
                  </div>
                </div>
                <!-- 骨架屏 -->
                <skeleton-view v-if="item.skeletonLoading === true && item.activeName !== 'select'" :h="item.h" />
              </div>

              <!-- 容器组件 -->
              <div v-else-if="item.type === 'container'"
                  :class="['grid-drage summarizing grid-container', item.transparentBackground ? 'bTransparent' : '', item.projectionTransparent ? 'pTransparent' : '']"
                  :style="bgfillSet(item.bgfillStyle,item.transparentBackground)">
                <div
                  v-if="!item.nameShow"
                  :style="[
                    item.summaryTitleConfig,
                    titleBgfillSet(item),
                    { justifyContent: (item.summaryTitleConfig && item.summaryTitleConfig.textAlign || 'left') }
                  ]"
                  class="container-title">{{ item.reName }}</div>
                <div :class="item.navbarPosition === 'left' ? 'container-style-left' : ''" :style="{height: 'calc( 100% - ' + (!item.nameShow ? 53 : 0) + 'px)' }">
                  <div v-if="isFrontEnd" class="container-header">
                    <i class="iconfont icon-bianji container-header-list" @click="containerEditorFun(item, index)" />
                    <i class="iconfont icon-shanchu5 container-header-list" @click="handle({status: 'delete',index: index})" />
                    <i class="iconfont icon-yincangxianshi container-header-list" @click="viewShowFun({item: item, index: index})" />
                    <i class="iconfont icon-wenjianbeifen container-header-list" @click="handle({status: 'copy', item: item})" />
                    <i class="iconfont icon-zhuanhuan container-header-list" @click="handle({status: 'editDrid', index: index})" />
                  </div>
                  <container-header
                    v-model:config="layout[index]"
                    :index="index"
                    :isFrontEnd="isFrontEnd"
                    @upSelected="containerUpSelected" />
                  <container-content 
                    :layout="layout"
                    :config="item"
                    :index="index"
                    :isFrontEnd="isFrontEnd"
                    :draggable="draggable"
                    :styleSync="styleSync"
                    :disabled="disabled"
                    :theme="theme"
                    :reviseObj="reviseObj"
                    :saveRevise="saveRevise"
                    :dashboardId="id"
                    @closeButton="closeButton"
                    @rSetReviseRow="rSetReviseRow"
                    @upSummary="upSummary"
                    @contentUsual="contentUsual"
                    @goSearchList="goSearchList"
                    @goSummarySearch="goSummarySearch"
                    @contentRetRefresh="contentSearch"
                    @addCount="containerEditorFun(item, index)"
                    @upLoadPage="upLoadPage"
                    @singleRelevance="singleRelevance"
                    @contentSearch="contentSearch"
                    @containerHandle="containerHandle"
                    @changeRelevanceFun="changeRelevanceFun"
                    @containerPageChange="containerPageChange"
                    @containerSumPageChange="containerSumPageChange"
                    @containerIndicatorsChange="containerIndicatorsChange"
                    @containerText="changeFatoSon"
                    @handleSet="containerTextSet"
                    @addContainer="addContainer" />
                </div>
              </div>

              <!-- 应用列表 -->
              <div v-else-if="item.type === 'mutual'"
                  :class="['grid-drage detailing', item.transparentBackground ? 'bTransparent' : '', item.projectionTransparent ? 'pTransparent' : '']" style="padding: 0;width:100%">
                <select-box
                  v-if="isFrontEnd"
                  :data="item"
                  :index="index"
                  :draggable="draggable"
                  :resizable="resizable"
                  :isFrontEnd="isFrontEnd"
                  @handle="handle"
                ></select-box>
                 <mutual-view v-else :themeColor="item.themeColor" :organizationType="organizationType"
                        :dataInfo="item" :index="index" :ref="item.i + 'mutual'" />

              </div>

              <!-- 图片组件 -->
              <div v-else-if="item.type === 'swiper'"
                :class="['grid-drage', item.transparentBackground ? 'bTransparent' : '', item.projectionTransparent ? 'pTransparent' : '']"
                style="box-shadow:none;border:none;">
                <!-- <select-box
                  v-if="isFrontEnd"
                  :data="item"
                  :index="index"
                  :width="windowWidth"
                  :draggable="draggable"
                  :resizable="resizable"
                  :isFrontEnd="isFrontEnd"
                  @handle="handle"
                ></select-box> -->

                <!-- 滚动图 -->
                <roll
                  ref="gird-item"
                  :dataInfo="item"
                  :isPreview="false"
                  :themeColor="'#4e86ff'"
                  :compRadius="'n'"
                  @edit="editToolsFun"
                  :style="{
                    borderRadius: 0
                  }"
                />
              </div>
            </template>

          </grid-item>
        </template>
      </grid-layout>

    <!-- 扩大内容显示       :theme="theme" -->
    <drawer
      ref="drawerRefs"
      v-if="drawer === true"
      :theme="drawerDatas.themeConfig && JSON.stringify(drawerDatas.themeConfig) != '{}' ? drawerDatas.themeConfig : theme"
      v-model:drawer="drawer"
      :drawerDatas="drawerDatas"
      :draggable="draggable"
      :resizable="resizable"
      :isFrontEnd="isFrontEnd"
      :disabled="disabled"
      :layoutLength="layout.length"
      :drawerDatasIndex="drawerDatasIndex"
      @singleRelevance="(item) => singleRelevance(item, true)"
      @editCallBack="editCallBack"
    ></drawer>

    <!-- 下载进度条 -->
    <progressces ref="progressRefs" @close="progressShow = false" v-if="progressShow"></progressces>

    <!-- 人物选择 -->
    <multiple-choice
      ref="multipleChoiceRef"
      @fromMultipleChoice="fromMultipleChoice"
    />
    <!-- 跳转选择 -->
    <jump v-model:visible="isJump" :openArr="jumpArr" @jump="goOpen" />
    <!-- 本页 url 弹窗 -->
    <el-dialog
      v-if="popUps"
      class="popUps"
      append-to-body
      top="0"
      @close="dialogClose"
      v-model="popUps"
      :width="popUpsObj.popUps.w + 'px'">
        <iframe :style="{height:popUpsObj.popUps.h + 'px'}"
                :frameborder="0"
                seamless
                scrolling="auto"
                allowtransparency="true"
                id="iframe"
                :height="popUpsObj.popUps.h"
                width="100%"
                :src="popUpsObj.url" />
    </el-dialog>
    <AppDialog
      :dialogInfo="dialogInfo"
      :iId="openInput.iId"
      v-model:isDetail="openInput.isDetail"
      :appId="openInput.approvalId"
      v-model:addInputShow="openAddInputShow"
      :coverVal="openInput.search"
      :datatype="openInput.datatype"
      @close="doorUpCloe" />
    <!-- 存储状态 -->
    <memoryStatus ref="memory" @memoryGo="memoryGo" @endStatus="$emit('endStatus')" />
    <editUserInfoDrawer v-model:isView="isShowEidtUser" :userInfo="editUserInfo" :editUserInfoKey="editUserInfoKey" />
    <!-- <Success-loading :show="isShowSucloading" :animationStyle="animationStyle" :isInstrument="true" /> -->

  </div>
</template>

<script>
import { GridLayout, GridItem } from 'grid-layout-plus'
import drageGridNav from "./drageGridNav.vue";//- 分页控件骨架
import selectBox from './selectBox.vue';//- 操作组件
import progressces from './progress.vue';//- 进度条组件
import multipleChoice from '@/components/common/multipleChoice.vue';//- 联系人组件
import skeletonView from '@/components/common/skeletonDrawing.vue';//- 仪表盘内容骨架屏加载组件
import tableDetail from './detailed/tableDetail.vue';//- 仪表盘明细表格骨架
import sumTable from './summaryModel/sumTable.vue'//- 汇总表显示组件骨架
import sizerDetail from './sizer/sizer.vue';//- 仪表盘筛选组件骨架
import indicatorsDetails from './indicatorsBread/indicatorsDetails.vue'//- 指标图图表骨架
import breadDetails from './indicatorsBread/breadDetails.vue'//- 饼图图表骨架
import proportionDetails from './indicatorsBread/proportionDetails.vue'//- 面积图图表骨架
import columnarDetails from './indicatorsBread/columnarDetails.vue'//- 柱状图图表骨架
import columnarStacking from './indicatorsBread/columnarStacking.vue'//- 柱状堆积图
import annularDetails from './indicatorsBread/annularDetails.vue'//- 环形图图表骨架
import brokenLineDetails from './indicatorsBread/brokenLineDetails.vue'//- 折线图图表骨架
import barTypeDetails from './indicatorsBread/barTypeDetails.vue'//- 条形图图表骨架
import scatter from './indicatorsBread/scatter.vue'// 散点图
import timeline from './indicatorsBread/timeline.vue'// 时间轴
import radar from './indicatorsBread/radar.vue'// 雷达图
import candlestick from './indicatorsBread/candlestick.vue'// k线图
import heatmap from './indicatorsBread/heatmap.vue'// 热力图
import mapContainer from './indicatorsBread/MapContainer.vue'// 地图
import treemap from './indicatorsBread/treemap.vue'// 矩形树图
import drawer from './drawer/drawer.vue'//-  扩大区域骨架
import mutualView from '@/components/schoolInstrument/component/mutual/index'
import textCpn from './text/index' // 文本组件

import containerHeader from './container/header'
import containerContent from './container/content'
import toolbar from './toolbar/index'
import memoryStatus from './memoryStatus/index.vue'
import partition from './summaryModel/partition.vue';


import { reportpreviewResult, getbuttonpermission, updatesummfeilds } from '@/port/admins/instrument'
import { axiosBase } from '@/api/api'//- 自由请求接口
import { apiUpateview, apiUploadview, apiGetmiddleuserbyid, deletelastrecentdata, importapprovaldashboarddatalist } from '@/port/admins/instrument'//- 表格数据请求接口
import {
  generate_IsMathRandom,
  generGrid, timeSub,
  numberSub, textSub,
  filterSymbol,
  serverPageSummary,
  getGenerateTableTopTwo,
  screeningRules,
  filterStr,
  nextProcess,
  getShowFiled,
  getHidenList,
  toolbarSearch
} from '@/api/instrumentControl';//- 封装方法请求
import { uploaderFun } from "@/api/utils.js";
import qs from 'qs'
import { goAppId } from '@/lib/color'
import { getConfig, mapClient, purviewObj, treemapClient } from "../utils/getConfig";
import { visualizationClient } from './indicatorsBread/js/color'
import { getappperAuthority } from "../../../../port/schoolInstrument/appConfig";
import { getUserLists } from "../utils/utils";
import { openapiGetapproval, apiGetapproval } from '@/port/clientSide/applicationRouting'
import { getWeek } from '@/api/styleUtils'
import { setConfigCustomData, setCustomData, getCustomVal } from '@/util/customData.js'
import { getapiuserlist } from "@/port/clientSide/multipleChoice";
import { getOrgShowName, formatDate } from "@/api/global.js";

import { cloneDeep, debounce } from 'lodash'
import { defineAsyncComponent } from 'vue';

export default {
  name: "drageGrid",
  components: {
    GridItem,
    GridLayout,
    drageGridNav,
    selectBox,
    progressces,
    multipleChoice,
    sumTable,
    skeletonView,
    tableDetail,
    sizerDetail,
    indicatorsDetails,
    breadDetails,
    proportionDetails,
    columnarDetails,
    columnarStacking,
    annularDetails,
    brokenLineDetails,
    barTypeDetails,
    scatter,
    timeline,
    radar,
    candlestick,
    heatmap,
    mapContainer,
    treemap,
    drawer,
    containerHeader,
    containerContent,
    toolbar,
    mutualView,
    jump: defineAsyncComponent(() => import('./jump')),
    // viewSys: () => import('./viewSys'),
    roll: defineAsyncComponent(() => import('./roll/index.vue')), // 滚动图
    memoryStatus,
    textCpn,
    partition,
    AppDialog: defineAsyncComponent(()=> import('@/components/schoolInstrument/mixins/AppDialog.vue')),
    editUserInfoDrawer: defineAsyncComponent(() => import('@/components/admins/organization/common/editUserInfo')),
    IconModule: defineAsyncComponent(() => import('@/components/common/icon/iconModule.vue'))
  },
  props: {
    seriesType:{
      type:String
    },
    //- 是否可以编辑
    disabled: {
      type: Boolean,
      default: false
    },
    //- draggable 是否可拖拽
    draggable: {
      type: Boolean,
      default: true
    },
    //- resizable 是否可调整大小
    resizable: {
      type: Boolean,
      default: true
    },
    //- isFrontEnd是否为前端或者后端展示:true为后端,false为前端
    isFrontEnd: {
      type: Boolean
    },
    styleTemp:{
      type:Object,
      default:()=>({
        radio:'default',
        color:'#fff',
        image:'',
        imgUrl:'',
        absorb:'open',
        region: false,
        ruler: false,
        rulerColor: '#000'
      })
    },
    theme: Object,
    organizationType: {
      type: Array,
      default: () => []
    },
    isShowCard: {
      type: Boolean,
      default: false
    },
    id: {
    },
    customDeskInfo: {
      type: Object,
      default: ()=> ({})
    },
    addUpRevise: Object
  },
  computed: {
    bgstyle () {
      const obj = {
        margin: '0 auto',
        transform: `scale(${this.scaleNum})`,
        transformOrigin: this.scaleNum > 1 ? 'left top' : 'center top'
      }
      if (this.styleTemp.canvasConfig) {
        const canvasConfig = this.styleTemp.canvasConfig
        obj.width = canvasConfig.canvasType === 1 ? canvasConfig.canvasSize.width + 'px' : '100%'
        obj.height = canvasConfig.canvasType === 1 ? canvasConfig.canvasSize.height + 'px' : '100%'
        obj.overflow = canvasConfig.canvasType === 1 ?  'hidden' : ''
        obj.background = this.disabled && canvasConfig.canvasGrid.isGrid ? 'url(https://bigdata.topeti.com/PCRepository/middleground/home/images/bg-grid.png)' : ''
        obj.backgroundSize = `${canvasConfig.canvasGrid.gridSize || 130}%`
      }
      if (this.styleTemp.radio === 'color') {
        obj.backgroundColor = this.styleTemp.color
      } else if (this.styleTemp.radio === 'image') {
        obj.backgroundImage = `url(${this.$imgurl + this.styleTemp.image})`
      } else if (this.styleTemp.radio === 'link') {
        obj.backgroundImage = `url(${this.styleTemp.imgUrl})`
      }
      return obj
    },
  },
  provide() {
    return {
      isSpace: this.isSpace
    }
  },
  data () {
    return {
      dialogInfo: {
        dialogName: '',
        isVisible: false,
        dialogWidth: '80%',
        dialogHeight: '85vh',
        openType: 'dialog',
        customSize: 65,
        dialogUrl: '',
        diaSize: '80%',
        childDialog: true
      },
      openInput: {
        isVisible: false,
        approvalId: '',
        search: {},
        iId: '',
      },
      openAddInputShow: false,
      scaleNum: 1,
      //- 例子：{"x":0,"y":2,"w":3.28,"h":13.5,"i":"1", resizable: true, draggable: true, static: false}
      layout: [],// grid-layout组件参数：static 是否不可拖拽 draggable 是否可拖拽 resizable 是否可调整大小 minW 最小宽 minH 最小高
      colNum: 192,//- grid-layout组件参数：计算块大小参数（暂定），请勿修改
      rowHeight: 10,//- grid-layout组件参数
      mirrored: false,//- grid-layout组件参数
      preventCollision: false,//- grid-layout组件参数
      responsive: true,//- grid-layout组件参数
      //- 扩大显示参数
      drawer: false,
      drawerDatas: {},
      drawerDatasIndex: 0,
      //- 是否重新刷新表数据以及如果是筛选组件的话的文本类型要查询最新的文本数据 false不用，true需要
      whetherUpdate: false,
      //- 是否显示加载进度条
      progressShow: false,
      //- 筛选组件触发内容标记
      screenIndex: 0,//- 筛选组件所在数据源的序号层级
      whetherTurn: false,//-  筛选组件触发后，关联页数要还原
      // 弹窗选择
      jumpArr: [],
      isJump: false,
      // 弹窗
      popUps: false,
      popUpsObj: '',
      // 是否可拖拽判断
      draggableObj: {},
      // 单个点击的
      tableSelectValue: {},
      isSpace: false, // 是否从空间进入
      isUpace: false, // 是否从空间进入
      // 列表组件筛选值存储集合使用(以字段为区分)
      mutualSearchObj: {
        // '字段title+type':{'筛选器id':['这边是筛选器值']}
      },

      // 去编辑暂存
      goEdit: {},
      isEdit: false,
      spaceid:this.$route.query.spaceid,
      upaceid:this.$route.query.upaceid || localStorage.getItem('upaceid'),
      editUserInfoKey: {},
      editUserInfo: {},
      isShowEidtUser: false,

      reviseObj: {},
      saveRevise: {},
      isShowSucloading: false,
      setTimeShowSucloading: null,
      isAjaxLoading: false,
      indicatorsIdx: null, //系统数据表（可视化下标）
      animationStyle: {
        animationList: [{
          name:"样式一",
          text:"保存成功",
          value:0
        }],
        value:0
      },
      windowWidth: 0
    }
  },
  created () {
    const spaceId = this.$route.query.spaceid
    const spaceStatus = this.$route.query.space
    const upaceId = this.$route.query.upaceid
    const upaceStatus = this.$route.query.upace
    if (typeof(spaceId) !== 'undefined' || spaceStatus){
      this.isSpace = true
    }
    else if (typeof(upaceId) !== 'undefined' || upaceStatus){
      this.isUpace = true
    }
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
    try {
      //除了火狐、IE的写法                                //火狐兼容写法
      window.addEventListener("mousewheel",this.roller,{ passive: false })||window.addEventListener("DOMMouseScroll",this.roller,{ passive: false });
    } catch(e) {
      //IE兼容写法
      window.attachEvent("mousewheel",this.roller,{ passive: false });
    }
  },
  beforeUnmount () {
    window.removeEventListener('resize', this.handleResize)
    try{
      //除了火狐、IE的写法                                //火狐兼容写法
      window.removeEventListener("mousewheel",this.roller,{ passive: true })||window.removeEventListener("DOMMouseScroll",this.roller,{ passive: true });
    }catch(e){
      //IE兼容写法
      window.detachEvent("mousewheel",this.roller,{ passive: true });
    }
  },
  methods: {
    handleResize: debounce(function() {
      this.windowWidth = window.innerWidth;
    }, 200),
    getLegend (item) {
      if (item.legend && item.legendKey) {
        const ind = item.summary.findIndex(it => it.title === item.legendKey)
        if (ind !== -1 && item.summary[ind].colorConfig && item.summary[ind].colorConfig.colorType == 3) {
          return item.summary[ind].colorConfig.options || []
        }
      }
      return []
    },
    closeButton (i) {
      const ind = this.layout.findIndex(it => it.i === i)
      if (ind !== -1) {
        this.layout[ind].upRevise = ''
        this.reviseObj[i] = {}
        this.saveRevise[i] = false
        this.animationStyle = {
          animationList: [{
            name:"样式一",
            text:"保存成功",
            value:0
          }],
          value:0
        }
        this.$emit('upSummaryInst', { key: 'addUpRevise', config: {}})
        this.$emit('upSummaryInst', { key: 'animationStyle', config: {
          animationList: [{
            name:"样式一",
            text:"保存成功",
            value:0
          }],
          value:0
        } })
      }
    },
    rSetReviseRow ({ key, sum, rInd, sumL, row, value, i }) {
      console.log('返回过来进行存储的', key, sum, sumL, row, value, i)
      if (!this.reviseObj[i]) this.reviseObj[i] = {}
      const label = key + rInd
      const kkk = JSON.parse(JSON.stringify(this.reviseObj[i]))
      if (!kkk[label]) {
        const ob = {
          sum: sum,
          row: row,
          value: value,
          sumL: sumL
        }
        kkk[label] = ob
      } else if (kkk[label].value.name !== value.name) {
        kkk[label].value = value
      }/*  else  {
        delete kkk[key]
      } */
      this.reviseObj[i] = kkk
    },
    async upSummary (config) {
      console.log('外层的汇总处理', config)
      const ind = this.layout.findIndex(it => it.i === config.uId)
      if (ind !== -1) {
        const item = this.layout[ind]
        if (!item.revise) {
          this.$message.warning('修改模式已关闭!')
          return
        }
        if (item.upRevise && item.upRevise.i !== config.i || this.addUpRevise && this.addUpRevise.i && this.addUpRevise.i !== config.uId) {
          this.$message.warning('有内容正在修改！')
          return
        }
        if (item.upRevise && item.upRevise.i === config.i) {
          console.log('去保存', this.reviseObj[item.i])
          if (item.reviseConfig && item.reviseConfig.required) {
            this.saveRevise[config.uId] = true
            if (this.getSaveRevise(item, this.reviseObj[item.i])) {
              this.$message.warning('请选择完善！')
              return
            }
          }
          const ll = Object.values(this.reviseObj[item.i])
          const upRevise = item.upRevise
          if (ll.length > 0) {
            // console.log('过滤条件', JSON.stringify(upRevise))
            // console.log('参数条件', JSON.stringify(ll))
            const upL = []
            const customData = this.$store.state.dashboardCustomDataObj[this.id] || []
            for (const i of ll) {
              const ob = {
                id: upRevise.config.appid,
                isarchive: upRevise.config.isarchive,
                where: [],
                list: []
              }

              for (const a of upRevise.config.where) {
                  // console.log('遍历获取过滤值', a, i, a.data_field)
                  const aob = {
                      type: "value",
                      field: a.field === 'orders_text' ? 'orders' : a.field,
                      value: a.type === 'value' ? a.value : a.type === 'empty' ? '' : (i.row[a.data_field] || ''),
                      relation:"eq"
                  }
                  if (customData && customData.length > 0 && a.data_field && a.data_field.includes('_custom')) {
                    const t = a.data_field.split('_')
                    const cuInd = customData.findIndex(it => it.title === t[0])

                    if (cuInd !== -1) {
                      if (customData[cuInd].type === 'relation-user') {
                        aob.value = (customData[cuInd].value || []).map(it => {
                          return {
                            userId: it.userId,
                            realname: it.realname,
                            orgname: it.orgname
                          }
                        })
                      } else {
                        aob.value = customData[cuInd].value
                      }
                    }
                  }
                  if (a.type === 'field' && !aob.value && aob.value !== 0) {
                    const isSum = (item.summary || []).findIndex(it => it.name === a.data_field)
                    if (isSum !== -1) {
                      const sv = i.sumL + filterStr(a.data_field)
                      aob.value = i.row[sv]
                    }
                  }
                  ob.where.push(aob)
              }
              for (const a of upRevise.config.fields) {
                  // console.log('遍历获取参数值', a, i)
                  const aob = {
                      type: "value",
                      field: a.field,
                      value: a.type === 'value' ? a.value : '',
                      relation:"eq"
                  }

                  if (a.type === 'field' && i.value && i.value.parameter) {
                      const ind = i.value.parameter.findIndex(it => it.i === a.data_field)
                      if (ind !== -1) {
                          aob.value = i.value.parameter[ind].value || ''
                      }
                  }
                  ob.list.push(aob)
              }
              upL.push(ob)
            }
            console.log('去走修改数据接口', upL)
            this.$emit('upSummaryInst', { key: 'isShowSucloading', config: true })
            this.isShowSucloading = true
            this.isAjaxLoading = true
            this.setTimeShowSucloading = setTimeout(() => {
              if (!this.isAjaxLoading) {
                this.isShowSucloading = false
                this.$emit('upSummaryInst', { key: 'isShowSucloading', config: false })
              }
              this.setTimeShowSucloading = null
            }, 2000)
            const res = await updatesummfeilds({ approvalId: upRevise.config.appid, datas: upL }).catch(err => { console.log(err) })
            console.log('修改结果', res)
            if (!this.setTimeShowSucloading) {
              this.isShowSucloading = false
              this.$emit('upSummaryInst', { key: 'isShowSucloading', config: false })
            }
            this.isAjaxLoading = false
            if (res.code === 0) {
              // this.$message.success(res.msg || '保存成功')
            } else {
              this.$message.error(res.msg || '保存失败')
            }
            this.getSummaryTable(ind, this.layout[ind], 1, false)
          }
          this.saveRevise[config.uId] = false
          this.layout[ind].upRevise = ''
          this.reviseObj[config.uId] = {}
          this.animationStyle = {
            animationList: [{
              name:"样式一",
              text:"保存成功",
              value:0
            }],
            value:0
          }
          this.$emit('upSummaryInst', { key: 'animationStyle', config: {
            animationList: [{
              name:"样式一",
              text:"保存成功",
              value:0
            }],
            value:0
          }})
          this.$emit('upSummaryInst', { key: 'addUpRevise', config: {}})
        } else {
          const upRevise = {
            i: config.i,
            list: {},
            config: config.insideInfo
          }
          let d = {}
          if (item.reviseConfig && (item.reviseConfig.defaultVal || item.reviseConfig.defaultVal === 0)) {
            const dInd = item.reviseConfig.config.findIndex(it => it.name === item.reviseConfig.defaultVal)
            if (dInd !== -1) {
              const dConfig = item.reviseConfig.config[dInd]
              let merge = JSON.parse(JSON.stringify(item.merge))
              const lee = item.row && item.row[0] && item.row[0].partition  ? -1 : 0
              if (!item.column || item.column.length === 0) {
                merge = merge.slice((item.row.length + lee), merge.length)
              } else {
                merge = merge.slice((1 + lee), merge.length)
              }
              const cre = this.getDefaultList(merge, [])
              for (let ee = 0; ee < item.tableData.length; ee++) {
                for (const ce of cre) {
                  const val = item.tableData[ee][ce.ind]
                  const vInd = item.reviseConfig.config.findIndex(it => it.name === val)
                  if (!(val === item.reviseConfig.defaultVal || vInd !== -1)) {
                    const label = ce.ind + '' + ee
                    const row = JSON.parse(JSON.stringify(item.tableData[ee]))
                    const sl = filterStr(ce.label)
                    const se = (ce.ind || '').substring(0, ce.ind.length - sl.length)
                    row[ce.label] = row[ce.ind]
                    d[label] = {
                      sum: ce.ind,
                      row: row,
                      value: dConfig,
                      sumL: se
                    }
                  }
                }
              }
            }
          }
          this.$emit('upSummaryInst', { key: 'addUpRevise', config: { i: config.uId, ii: config.i }})
          this.layout[ind].upRevise = upRevise
          this.reviseObj[config.uId] = d
          if (config.insideInfo.appid) {
            const res = await apiGetapproval({ approvalId: config.insideInfo.appid }).catch(err => { console.log(err) })
            if (res.data.addconfig) {
              try {
                const addconfig = JSON.parse(res.data.addconfig)
                this.animationStyle = addconfig.animationStyle
                this.$emit('upSummaryInst', { key: 'animationStyle', config: addconfig.animationStyle})
              } catch (err) { console.log(err) }
            }
          }
        }
      }
    },
    getSaveRevise (config, ob) {
      let merge = JSON.parse(JSON.stringify(config.merge))
      if (!config.column || config.column.length === 0) {
        merge = merge.slice(config.row.length, merge.length)
      } else {
        merge = merge.slice(1, merge.length)
      }
      const cre = this.getDefaultList(merge, [])
      for (const a of config.tableData || []) {
        for (const i of cre) {
          const val = a[i.ind]
          const vInd = config.reviseConfig.config.findIndex(it => it.name === val)
          const le = i.ind + '' + (a.rowIndex - 1)
          if (!(val === config.reviseConfig.defaultVal || vInd !== -1 || ob[le])) return true
        }
      }
    },
    getDefaultList (config, arr) {
      for (const i of config) {
            if (!i.children || i.children.length === 0) {
                arr.push(i)
            } else {
                arr = this.getDefaultList(i.children || [], arr)
            }
        }
        return arr
    },
    getSummary (summary) {
      const ob = {
        configNumber: {},
        colorConfig: {},
        headerView: {}
      }
      for (const i of summary) {
        if (i && i.isFormatNum) {
          ob.configNumber[i.name] = i.configNumber
        }
        if (i && i.isColor) {
          ob.colorConfig[i.name] = i.colorConfig
        }
        if (i.isShow) ob.headerView[i.name] = i.isShow
      }
      return ob
    },
    goSummarySearch(opt){
      const { id, order, query } = opt
      const i = this.layout.findIndex(its => its.i === id)
      if (i !== -1) {
        this.layout[i].order = order
        this.layout[i].query = query
        this.getSummaryTable(i, this.layout[i]);
      }
    },
    goSearchList(opt = {}) {
      const { val, order, query } = opt
      const i = this.layout.findIndex(its => its.i === val.i)
      if (i !== -1) {
        this.layout[i].order = order
        this.layout[i].query = query
        this.getNewFromDatas(i, this.layout[i]);
      }
    },
    doorUpCloe() {
      if (this.$store.state.doorCustomDataObj[this.customDeskId]) {
        const customData = this.$store.state.doorCustomDataObj[this.customDeskId]
        this.$store.commit('changeCustomData', { key: 'door', value: customData });
      }
      this.openInput = {
          isVisible: false,
          approvalId: '',
          search: {},
          iId: ''
      },
      this.dialogInfo = {
        dialogName: '',
        isVisible: false,
        dialogWidth: '80%',
        dialogHeight: '85vh',
        openType: 'dialog',
        customSize: 65,
        dialogUrl: '',
        diaSize: '',
        childDialog: true
      }
    },
    changeFiled(item, list) {
      item.skeletonLoading = true;
      const defaultMerge = item.defaultMerge
      const column = item.column
      let row = 1
      if (column.length === 0) {
        row = item.row.length
      }
      const first = defaultMerge.slice(0, row)
      const top = getHidenList(defaultMerge.slice(row, defaultMerge.length), list)
      top.unshift(...first)
      item.merge = top
      setTimeout(() => {
        item.skeletonLoading = false;
      }, 300);
    },
    toolbarEditUser ({config, i, user}) {
      const v = this.tableSelectValue[i]
      if (v && v.index !== undefined) {
        this.editUser(config, user[v.index])
      } else {
        this.$message.error('请选择一条数据')
      }
    },
    async editUser (config, value) {
      console.log(config, value)
      if (config.editFeild) {
        const key = config.editFeild.split('_')[1]
        const editFeildList = config.editFeildList
        const user = value[key]
        if (user[0] && user.length === 1){
          const { data } = await getapiuserlist({userids: user[0].userId, curpage: 0, pagesize: 1})
          if (data && data[0]) {
            this.editUserInfo = data[0]
            this.editUserInfoKey = editFeildList
            this.isShowEidtUser = true
          } else {
            this.$message.warning('用户不存在')
          }
        } else {
          this.$message.warning('无法修改')
        }
      }
    },
    getIndicatorsBreadHeight (item) {
      let h = 0
      if (item.chartType === 'indicators' && item.row && item.row.length > 0) h += 45
      if (!item.nameShow || item.toolbar || item.titleMom || item.titleMom === undefined || item.chartTypeMom) h += 60
      return { height: 'calc(100% - ' + h + 'px)' }
    },
    upTemp () {
      const layout = JSON.parse(JSON.stringify(this.layout))
      layout.forEach(item => {
        if (item.type === 'indicatorsBread') {
          item.themeConfig = {}
        }
      })
      this.layout = layout
    },
    upchart (val, item, index) {
      if (!this.isFrontEnd) {
        this.layout[index].echartsTempId = val.echartsTempId || val.echartsTempId === 0 ? val.echartsTempId : -1
        this.layout[index].chartType = val.chartType || val
        this.layout[index].themeConfig = val.themeConfig || {}
        this.handle({index: index, item: this.layout[index], status: 'update'})
      }
    },
    // 监听滚轮事件
    roller(e){
      if(e.ctrlKey === true || e.metaKey){
        e.preventDefault()
        if (e.wheelDelta) {  //判断浏览器IE，谷歌滑轮事件
          if (e.wheelDelta > 0) { //当滑轮向上滚动时
            this.canvasUpZoom()
          }
          if (e.wheelDelta < 0) { //当滑轮向下滚动时
            this.canvasReduceZoom()
          }
        }
        else if (e.detail) {  //Firefox滑轮事件
          if (e.detail> 0) { //当滑轮向上滚动时
            this.canvasUpZoom()
          }
          if (e.detail< 0) { //当滑轮向下滚动时
            this.canvasReduceZoom()
          }
        }
      }
    },
    // 缩放画布
    canvasUpZoom(){
      if(this.scaleNum < 2){
        this.scaleNum +=.05
      }
    },
    canvasReduceZoom(){
      if(this.scaleNum > 0.25){
        this.scaleNum -=.05
      }
    },
    updateTitleConfig (val) {
      const isIcon = ['detailed', 'summary', 'indicatorsBread']
      this.layout.forEach(item => {
        if (val.summaryTitleConfig && item.summaryTitleConfig !== undefined) {
          item.summaryTitleConfig = JSON.parse(JSON.stringify(val.summaryTitleConfig))
        }
        if (val.titleBgConfig && item.titleBgConfig !== undefined) {
          item.titleBgConfig = JSON.parse(JSON.stringify(val.titleBgConfig))
        }
        if (val.bgfillStyle && item.bgfillStyle !== undefined) {
          item.bgfillStyle = JSON.parse(JSON.stringify(val.bgfillStyle))
        }
        if (val.iconConfig && isIcon.includes(item.type)) {
          item.img = JSON.parse(JSON.stringify(val.iconConfig))
        }
      })
      this.$forceUpdate()
    },
    titleBgfillSet (data) {
      const titleBgConfig = data.titleBgConfig
      const transparentBackground = data.transparentBackground
      if (titleBgConfig && !transparentBackground) {
        let fillstyle = {}
        if (titleBgConfig.bgType === 'color') {
          fillstyle.backgroundColor = titleBgConfig.bgColor
        } else if (titleBgConfig.bgType === 'picture') {
          fillstyle.background = `url('${this.$imgurl + titleBgConfig.bgImg}') no-repeat`
          fillstyle.backgroundSize = '100% 100%'
        } else if(titleBgConfig.bgType === 'temp') {
          // 背景填充颜色
          fillstyle.backgroundColor = '#333'
          fillstyle.backgroundRepeat = 'no-repeat'
          fillstyle.backgroundSize = '100% 100%'
          if (titleBgConfig.bgTemp === 2) {
            fillstyle.backgroundColor = '#FFF'
          }
          fillstyle.backgroundImage = `url(https://bigdata.topeti.com/PCRepository/mainPlatform/dashboardTitleBg${titleBgConfig.bgTemp + 1}.png)`
        }
        return fillstyle
      }else{
        return ''
      }
    },
    // 富文本编辑返回
    richTextEditCallBack ({formData, functionParms, index}) {
      this.layout[index].bindinf = formData
      this.layout[index].functionParms = functionParms
    },
    // 文本设置的回调
    setCallBack (val, index) {
      this.layout[index] = val
    },
    // 容器文本设置回调
    containerTextSet ({ val, list }) {
      this.layout[list] = val
    },
    contentUsual ({config, i}) {
      console.log('容器出来方法', config, i)
      this.usual(config, i)
    },
    memoryGo (e) {
      console.log('状态跳转', e, e.status === 'success')
      if (e.status === 'success') {
        // 去查看全部数据
        const url = this.$url + '/clientSide/application?approvalId=' + e.config.info.insideInfo.appid + '&iId=7&source=user&navShow=false&dataId=7'
        switch (e.config.info.insideInfo.open) {
          case 2:
            this.popUpsObj = {
              url: url,
              popUps: e.config.info.insideInfo.popUps
            }
            this.popUps = true
            break
          case 3:
            window.open(url)
            break
          case 4:
          window.location.href = url
            break
        }
      } else {
        // 重新同步
        this.usual({config: e.config, type: e.type}, e.i)
      }
    },
    // 工具条返回的新增能力（下载、刷新、放大、存储）
    async usual (obj, i) {
      const { config, type, memoryEditCheck } = obj
      console.log('工具条新增能力', obj, config, type, i)
      const index = this.layout.findIndex(it => it.i === i)
      if (type === 'memory') {
        let submitDatas = {}
        if (config.info.isCheckData) {
          // 选择数据去存储
          let dataList = cloneDeep(this.layout[index].selectionList)
          if (!dataList || dataList.length === 0) return this.$message.warning('请选择数据！')
          if (this.layout[index].fromdatasOriginal) {
            dataList = dataList.map(iten => {
              return this.layout[index].fromdatasOriginal[iten.index] || iten
            })
          }
          const importindex = this.layout[index].importConfig.findIndex(it => it.i === config.i)
          submitDatas = {
            datalist: dataList,
            approvalDashboardId: this.$parent.submitDataAlls.approvalDashboardId,//- 仪表盘id
            index: index,//- 仪表盘索引
            importindex: importindex
          }
          console.log(dataList, 'dataList')
        } else {
          // 直接获取数据去存储
          let mergeRules = [];
          if (this.layout[index].rules && this.layout[index].rules != undefined) {
            //- 外置筛选组件的筛选规则
            mergeRules = mergeRules.concat(this.layout[index].rules);
          }
          if (this.layout[index].relevanceRules && this.layout[index].relevanceRules != undefined) {
            //- 表单关联表单的筛选规则
            mergeRules = mergeRules.concat(this.layout[index].relevanceRules);
          }
          const importindex = this.layout[index].importConfig.findIndex(it => it.i === config.i)
          submitDatas = {
            approvalDashboardId: this.$parent.submitDataAlls.approvalDashboardId,//- 仪表盘id
            index: index,//- 仪表盘索引
            value: JSON.stringify(mergeRules),//- 筛选组件提交的筛选值
            curpage: 0,//- 当前页
            pagesize: 0,//- 每页条数
            querys: this.layout[index].querys ? this.layout[index].querys : '',//- 仪表盘验证过滤数据
            importindex: importindex
          }
          // 从空间进入，需要传空间id
          if(this.isSpace){
            let spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
            submitDatas.spaceid = spaceId;
          }
          else if (this.isUpace) {
            let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
            submitDatas.upaceid = upaceId
          }
          const datas = this.layout[index]
          const customDataList = this.$store.state.dashboardCustomDataObj[this.$parent.submitDataAlls.approvalDashboardId] || this.$store.state.dashboardCustomData || []
          if (customDataList.length > 0) {
            // 存在$就是自定义的变量
            submitDatas.customData = setCustomData(customDataList)
          }
          if (datas.isSource === 2 && Array.isArray(datas.variableconfig) && datas.variableconfig.length > 0) {
            const customData = submitDatas.customData ? submitDatas.customData : {}
            const variableconfig = await setConfigCustomData(cloneDeep(datas.variableconfig))
            console.log(variableconfig, '工坊变量')
            variableconfig.forEach(item => {
              customData[item.name] = item.value || item.value === 0  ? item.value : ''
            })
            submitDatas.customData = JSON.stringify(customData)
          }
        }
        if (config.info.editConfirm) {
          submitDatas.editConfirm = memoryEditCheck || false
        }
        // 告诉父组件打开存储组件了
        this.$refs.memory.opStatus()
        const fn = config.info.isCheckData ? importapprovaldashboarddatalist : apiUploadview
        const res =  await fn(submitDatas).catch(err => { console.log(err) })
        console.log('下载', res)
        if (config.info && config.info.isShow || config.info.isShow === undefined) {
          // TODO
        } else {
          this.$refs.memory.isButton = false
        }
        this.$refs.memory.open(res, config.info.text, {config: config, type: type, i: i})
        // this.$refs.memory.open(res)
      } else {
        this.handle({index: index, item: this.layout[index], status: type})
      }
    },
    // - 功能区域--编辑功能
    async editToolsFun (datas) {
      console.log('编辑功能', datas)
      if(datas.type === 'mutual')this.$emit('mutualEditor', datas)


      this.goEdit = cloneDeep(datas)
      this.isEdit = true
    },

    selectedTable (val, item) {
      if (!this.isFrontEnd) {
        this.tableSelectValue[item.i] = val
      }
    },
    singleRelevanceConfig (val, item) {
      if (this.isFrontEnd) return
      console.log('单个点击查询出来', val, item, this.tableSelectValue[item.i])
      // 明细控件需要选择了数据才能点
      if (item.type === 'detailed' && !this.tableSelectValue[item.i] && ((val.item.linked && val.item.linked.length > 0) || (val.item.customize && val.item.customize.length > 0))) {
        this.$message.warning('请选择一条数据~~')
        return
      }
      // 对象是明细才并且配置是按钮才给
      if (this.tableSelectValue[item.i]) {
        val.value = this.tableSelectValue[item.i].val
        val.user = item.user[this.tableSelectValue[item.i].index]
      }
      this.singleRelevance(val)
    },
    searchRelevanceConfig ({search, i}) {
      console.log('搜索数据，直接查入到对应搜索', search)
      const e = this.layout.findIndex(its => its.i === i)
      let isCustom = false
      if (e !== -1) {
        if (search.isCustom) {
          isCustom = true
            // 筛选的是工坊的变量 就不通过value筛选
          if (this.layout[e].variableconfig && this.layout[e].variableconfig.length > 0) {
            const variableconfig = this.layout[e].variableconfig
            const index = variableconfig.findIndex(iter => { return search.customName === iter.name })
            if (index !== -1) {
              let val = ''
              if (Array.isArray(search.value) && variableconfig[index].type === 'date') {
                val = variableconfig[index].type2 === 'range' ? search.value : search.value[0]
              } else {
                val = Array.isArray(search.value) ? search.value.join() : search.value
              }
              this.layout[e].variableconfig[index].value = val
            }
            // 存在第二个值
            if (search.customName2) {
              const index2 = variableconfig.findIndex(iter => { return search.customName2 === iter.name })
              if (index2 !== -1) {
                let val = ''
                if (Array.isArray(search.value) && variableconfig[index2].type === 'date') {
                  val = search.value.length > 1 ? search.value[1] : search.value[0]
                } else {
                  val = Array.isArray(search.value) ? search.value.join() : search.value
                }
                this.layout[e].variableconfig[index2].value = val
              }
            }
          }
        }
        if (!isCustom) {
          const rules = cloneDeep(this.layout[e].rules)
          const rulesInd = rules.findIndex(ite => ite.filterId === search.filterId)
          // 查询是否存在对应值，没有的话就新增
          if (rulesInd !== -1) {
            this.layout[e].rules[rulesInd] = search
          } else {
            rules.push(search)
            this.layout[e].rules = rules
          }
        }
        this.contentSearch(e)
      }
    },
    // 搜索
    contentSearch (ind) {
      const item = this.layout[ind]
      switch (item.type) {
        case 'detailed':
          item.curpage = 1
          this.getNewFromDatas(ind, item, false)
          break
        case 'summary':
          item.devCurpage = 1
          this.getSummaryTable(ind, item, 1, false)
          break
        case 'indicatorsBread':
          item.devCurpage = 1
          this.getIndicatorsDetailsTable(ind, item, 1, false)
          break
      }
    },
    containerUpSelected (i) {
      console.log('切换选择', i)
      const ind = this.layout.findIndex(its => its.i === (i.i || i))
      if (ind !== -1) {
        const ites = this.layout[ind]
        if (ites.type === 'summary' || ites.type === 'indicatorsBread') {
          if (!ites.devArticle) ites.devArticle = 25;
          if (!ites.devCurpage) ites.devCurpage = 1;
        }
        if (ites.type === 'detailed') this.getNewFromDatas(JSON.parse(JSON.stringify(ind)), ites);
        if (ites.type === 'summary') this.getSummaryTable(JSON.parse(JSON.stringify(ind)), ites, 1);
        if (ites.type === 'indicatorsBread') this.getIndicatorsDetailsTable(JSON.parse(JSON.stringify(ind)), ites, 1);
      }
    },
    containerEditorFun (val, index) {
      console.log('容器组件编辑', val)
      this.$refs.containerEditorRef.open({item: val, index: index})
    },
    containerHandle (val) {
      const i = this.layout.findIndex(its => its.i === (val.i || val.item.i))
      if (i !== -1) {
        if (val.status === 'upload') {
          val.index = i
        }
        if (val.status === 'delete') {
          const selected = this.layout[val.iIndex].selected
          this.layout[val.iIndex].children[selected].children.splice(val.index, 1)
          val.index = i
        } else if (val.status === 'show' || val.status === 'update') {
          val.index = i
        }
        this.handle(val)
/*
        console.log("容器点击下去的", val)
        if (val.status === 'copy') {
          //- 明细表，汇总表复制
          if (val.item.skeletonLoading === true) {
            this.$message({
              showClose: true,
              type: 'info',
              message: '还没加载完无法复制'
            });
            return;
          }
          const date = JSON.parse(JSON.stringify(val.item));
          date.i = generate_IsMathRandom(this.layout)
          this.layout[val.iIndex].children.push(date.i)
          date[date.type === 'Sizer' ? 'datasName' : 'reName'] += '_拷贝';
          this.layout.push(date);
        } else {
          this.handle(val)
        }
*/
      }
    },
    containerIndicatorsChange (val) {
      // index 重新查询
      const i = this.layout.findIndex(its => its.i === val.i)
      if (i !== -1) {
        this.indicatorsChange(val)
      }
    },
    containerSumPageChange (val) {
      // index 重新查询
      const i = this.layout.findIndex(its => its.i === val.i)
      if (i !== -1) {
        this.sumPageChange(val)
      }
    },
    containerPageChange (val) {
      // index 要重新查
      const i = this.layout.findIndex(its => its.i === val.i)
      if (i !== -1) {
        val.index = i
        this.pageChange(val)
      }
    },
    upLoadPage (val) {
      console.log('容器过来的刷新方式', val)
      const index = this.layout.findIndex(its => its.i === val.i)
      this.layout[index].curpage = val.curpage
      this.getNewFromDatas(index, this.layout[index]);
    },
    dialogClose () {
      if (!this.popUps) {
        const meterId = window.localStorage.getItem('meterId')
        if (meterId && this.popUpsObj.meterId) {
          const index = this.layout.findIndex(its => its.i === this.popUpsObj.meterId)
          if (index !== -1) {
            this.getNewFromDatas(index, this.layout[index], this.drawer)
          }
        }
      }
    },
    // 高度获取
    getHeight (item) {
      const h = !item.nameShow || item.toolbar ? 50 : 0
      let article = item.type === 'detailed' ? item.article : item.devArticle
      if (!article && article !== 0) article = 20
      let h1 = item.pageTotal && item.pageTotal > article && (!item.loadSetting || item.loadSetting === 'pages') ? 50 : 0
      // if (item.pageTotal && item.pageTotal === 1 && h1 === 50) {
      //   h1 = 10
      // }
      // const h2 = item.toolbar ? 50 : ''
      // if (item.upRevise) h1 = h1 + 47
      let hh = h + h1
      if (item.type === 'summary') {
        hh += 10
      }
      if (this.getLegend(item).length > 0) {
        hh += 36
      }
      return {
        height: 'calc(100% - ' + hh + 'px)'
        // height: 'calc(100% - ' + (h + h1 + h2) + 'px)'
      }
    },
    // 滚动加载
    loadPage (val) {
      const i = this.layout.findIndex(its => its.i === val.i)
      if (i !== -1) {
        this.layout[i].curpage += 1
        this.getNewFromDatas(i, this.layout[i]);
      }
    },
    // 单个抛出处理
    async singleRelevance ({value, item, user, id, customScene}, drawer) {
      console.log('点击出来处理', value, item, user, drawer)
      if (this.panduanScene() === false) {
        //- 说明该状态不行数据关联
        return
      }
      // 如果是自定义场景，单独处理
      if (customScene) {
        console.log('自定义场景的处理', customScene)
        const { open, popUps } = item
        const custom = customScene
        const skey = this.$route.query.skey || this.$route.params.skey
        const url = '/customInstrument'
        let paramsList = JSON.parse(JSON.stringify(custom.paramsList || []))
        const query = { showNav: false, name: custom.params, customDeskId: custom.id }
        if (skey) {
          query.skey = skey
        }
        const paramsLists = []
        // 页面入参
        if (paramsList.length > 0) {
            const id = this.customDeskInfo && this.customDeskInfo.dataReportId ? this.customDeskInfo.dataReportId : ''
            const customData = this.$store.state.dashboardCustomDataObj[id] || this.$store.state.dashboardCustomData || []
            paramsList.forEach(iter => {
            const index = customData.findIndex(citer => citer.name === iter.currentParam)
            if (index !== -1) {
              iter.otherParam = {
                name: iter.otherParam,
                value: customData[index].value
              }
              paramsLists.push(iter.otherParam)
            } else {
              console.log('选择当前表格的数据', iter, value, item)
              // 选择表格数据的情况
              iter.otherParam = {
                name: iter.otherParam,
                value: value[iter.currentParam] || ''
              }
              paramsLists.push(iter.otherParam)
            }
          })
        }

        if (paramsLists.length > 0) query.paramsList = JSON.stringify(paramsLists)
        if (open === 2 || open === 5) {
          // 弹窗
          // console.log('打开参数', query, paramsLists)
          const obj = {
            2: 'dialog',
            3: 'new',
            4: 'old',
            5: 'rightdia'
          }
          const dialogInfo = {
            isVisible: true,
            dialogName: query.name,
            dialogWidth: popUps.w + 'px',
            dialogHeight: popUps.h + 'px',
            openType: obj[open],
            dialogUrl: `${url}?${qs.stringify(query)}`,
            customSize: popUps.customSize || '',
            diaSize: popUps.diaSize || 65,
          }
          this.dialogInfo = dialogInfo
        } else if (open === 3) {
          // 新窗口
          if (url.includes('/customInstrument')) {
            this.$openNewPage(url, query)
          } else {
            window.open(`${url}?${qs.stringify(query)}`, '_blank')
          }
        } else if (open === 4) {
          // 当前窗口
          if (url.includes('/customInstrument')) {
            this.$router.push({ path: url, query })
          } else {
            window.location.replace(url);
          }
        } else {
          this.$message.error('请选择打开方式')
        }
        return
      }
      // 如果 link 4 的时候代表他是能力空间的，这个单独走逻辑。因为他不需要带字段
      if (item.link === 4) {
        const res = await nextProcess(item.appid, this)
        console.log('返回的数据', JSON.stringify(res), item, !res.url && !res.item && res.item.type === 1)
        if (!res.url && !res.item && res.item.type === 1) {
        this.$message.error('没有跳转地址')
        return
      }
        switch (item.open) {
          case 2:
            this.popUpsObj = {
              url: res.url,
              popUps: item.popUps
            }
            this.popUps = true
            break
            case 3:
              window.open(res.url)
              break
            case 4:
              window.location.href = res.url
              break
        }
        return
      }
      // link 5 直接跳转场景
      if (item.link === 5) {
        if (!item.appid) return
        this.goOpen(item)
        return
      }
      // 非本表需要加权限查询判断,接入应用也不要，下面会走
      if (item.link === 2 && item.datatype !== 2 && item.datatype !== 7) {
        if (item.datatype === 1) {
        //   const aper = await this.getApper1(item)
        //   if (!aper) {
        //     this.$message.warning('您无权限查阅该页面!')
        //     return
        //   }
        // } else {
          const getPermissions = await this.getApper(item)
          const permissions = purviewObj[item.appIid]
          console.log('查询权限返回值', getPermissions, permissions)

          if (getPermissions.code === 0 && Array.isArray(getPermissions.data)) {
            const pInd = getPermissions.data.findIndex(its => its.key === permissions)
            if (pInd === -1) {
              this.$message.warning('您无权限查阅该页面!')
              return
            }
          }
        }
      }
      // link 1 本表组件 2 应用 3 链接
      // 自定的是否可以继续处理(当前逻辑弃用，欧说不作为验证使用 24-12-13)
      // if (item.customize) {
      //   for (const s of item.customize) {
      //     let val = value[s.name]
      //     if (s.type === 'textarea') val = (value[s.name]).split('\n').join('')
      //     if ((s.value || s.value === 0) && val != s.value) {
      //     // if (s.value || s.value === 0 && value[s.name] != s.value) {
      //       console.log('自定义条件不符合，则不处理',s, s.value, val)
      //       return
      //     }
      //   }
      // }

      // 链接的逻辑
      if (item.link === 3 || item.link === 2) {
        item.value = value
        if (user) item.user = user
        this.goOpen(item, 'detailed')
      } else {
        // 扩大状态不走本表仅传参和弹窗
        if (drawer && (item.open === 1 || item.open === 2)) {
          return false
        }
        // 应用则直接跳转，只有本表才走赋值
        // 搜索到本表的对标组件
        const i = this.layout.findIndex(its => its.i === item.id)
        if (i !== -1) {
          const layoutItem = JSON.parse(JSON.stringify(this.layout[i].relevanceRules))
          const s = layoutItem.findIndex(its => its.triggerId === id)
          if (s !== -1) {
            for (let a = 0; a < (layoutItem[s].datas || []).length; a++) {
              const item4 = layoutItem[s].datas[a]
              // 自定义配置处理(有type的就是自定义的)
              let userVal = value[this.datasReplace(item4.matchName)]
              if (item4.type && (item4.type === 'relation-user' || item4.type === 'appuser') && typeof user[item4.matchName] === "object") {
                // 汇总列字段配置联系人是没有用户 id 的
                if (item4.format === 'userId' || item4.format === 'realname') {
                  userVal = user[item4.matchName][item4.format]
                  // userVal = user[item4.fieldName][item4.format]
                } else {
                  console.log('查询用户id', user, item4.matchName)
                  const user = await this.getUserInfo(user[item4.matchName].userId)
                  // const user = await this.getUserInfo(val.user[item4.fieldName].userId)
                  userVal = user[item4.format]
                }
              } else if (item4.type && item4.type === 'date') {
                userVal = await this.getTime(userVal, item4.format)
              }
              if (value.length === 0) {
                item4.value = [];
              } else {
                let submitValue = value;
                if (!submitValue[this.datasReplace(item4.matchName)] && submitValue[this.datasReplace(item4.matchName)] !== 0) {
                  item4.value = [];
                } else {
                  item4.value[0] = userVal
                }
              }
            }
            this.layout[i].curpage = 1
            // 是明细，并且选了本表、弹窗。走一次赋值
            if (this.layout[i].type === 'detailed' && item.link === 1 && item.open === 2) {
              if (layoutItem && layoutItem.length > 0) {
                for (let sa = 0; sa < layoutItem.length; sa++) {
                  const saItem = JSON.parse(JSON.stringify(layoutItem[sa]))
                  if (saItem.formid === item.id && saItem.datas && saItem.datas.length > 0) {
                    for (let sae = 0; sae < saItem.datas.length; sae++) {
                      const ty = saItem.datas[sae].fieldName
                      if (value[ty] || value[ty] === 0) {
                        saItem.datas[sae].value.push(value[ty])
                      }
                    }
                  }
                  layoutItem[sa] = saItem
                }
              }
            }
            this.layout[i].relevanceRules = layoutItem
            // 给到数据去执行
            if (item.open === 2 || item.open === 3) {
              this.goOpen(item)
            } else {

              switch (this.layout[i].type) {
                case 'indicatorsBread':
                  this.getIndicatorsDetailsTable(i, this.layout[i], 1, drawer)
                  break
                case 'detailed':
                  this.getNewFromDatas(i, this.layout[i], true)
                  break
                case 'summary':
                  this.getSummaryTable(i, this.layout[i], 1, drawer)
                  break
              }
              // this.getNewFromDatas(i, this.layout[i], true)
            }
          }
        }
      }
    },
    
    //- 明细-----客户端请求表数据（放置顶层）
    async getNewFromDatas (index, datas, drawerClickStu) {
      const that = this;
      datas.skeletonLoading = true;//- 开启骨架屏
      // 系统数据表
      if(datas.isSource === 11){
        that.systemLoad(datas, 'form')        
        return
      }
      let mergeRules = [];
      if (datas.rules && datas.rules != undefined) {
        //- 外置筛选组件的筛选规则
        mergeRules = mergeRules.concat(datas.rules);
      }
      if (datas.relevanceRules && datas.relevanceRules != undefined) {
        //- 表单关联表单的筛选规则
        mergeRules = mergeRules.concat(datas.relevanceRules);
      }
      let submitDatas = {
        approvalDashboardId: that.$parent.submitDataAlls.approvalDashboardId,//- 仪表盘id
        index: index,//- 仪表盘索引
        value: JSON.stringify(mergeRules),//- 筛选组件提交的筛选值
        curpage: datas.curpage,//- 当前页
        pagesize: datas.article,//- 每页条数
        export: '',//- 是否导出数据,1为导出，其它不导出
        querys: datas.querys ? datas.querys : '',//- 仪表盘验证过滤数据
        query: datas.query ? datas.query : '',//- 仪表盘排序
        order: datas.order ? datas.order : '',//- 仪表盘输入框查询
      }
      // 从空间进入，需要传空间id
      if(this.isSpace){
        let spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
        submitDatas.spaceid = spaceId;
      }
      else if (this.isUpace) {
        let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        submitDatas.upaceid = upaceId
      }
      if (this.customDeskInfo && this.customDeskInfo.token) {
        submitDatas.accesstoken = this.customDeskInfo.token
      }
      let customDataList = this.$store.state.dashboardCustomDataObj[this.$parent.submitDataAlls.approvalDashboardId] || this.$store.state.dashboardCustomData || []
      if (customDataList) {
        if (this.draggable) {
          customDataList = await setConfigCustomData(cloneDeep(customDataList))
        }
        // 存在$就是自定义的变量
        submitDatas.customData = setCustomData(customDataList)
      }
      if (datas.isSource === 2 && Array.isArray(datas.variableconfig) && datas.variableconfig.length > 0) {
        const customData = submitDatas.customData ? submitDatas.customData : {}
        const variableconfig = await setConfigCustomData(cloneDeep(datas.variableconfig))
        console.log(variableconfig, '工坊变量')
        variableconfig.forEach(item => {
          customData[item.name] = item.value || item.value === 0 ? item.value : ''
        })
        submitDatas.customData = JSON.stringify(customData)
      }
      try {
        const res = await apiUpateview(submitDatas)
        console.log('回来数据111', JSON.parse(JSON.stringify(res)))
        datas.skeletonLoading = false;//- 骨架屏消失
        if (res.code === 0) {
          // if (res.user) datas.user = res.user
          const user = res.user && res.user.length > 0 ? res.user : this.getUserList(res.data.list)
          console.log('自行获取的', JSON.parse(JSON.stringify(user)), this.getUserList(res.data.list))
          let date = res.data.list;
          let originalData = cloneDeep(res.data.originalDatas);
          const orj = {}
          if (datas.selectDatas && datas.selectDatas.length > 0) {
            for (const bb of datas.selectDatas) {
              const nn = bb.revisabilityName || bb.name
              orj[nn] = bb.type
            }
          }
          date = that.merge(date, orj);
          console.log('处理完的数据', JSON.parse(JSON.stringify(date)))
          if (datas.type === 'detailed') {
            //- 明细表
            let selectDatas = datas.selectDatas;
            if (selectDatas && selectDatas.length > 0 && date && date.length > 0) {
              for (let i = 0; i < selectDatas.length; i++) {
                if (selectDatas[i].type === 'date'
                  || selectDatas[i].type === 'file'
                  || selectDatas[i].type === 'image'
                  || selectDatas[i].type === 'number' && selectDatas[i].tempNumber
                  || selectDatas[i].type === 'text' && selectDatas[i].encryption && selectDatas[i].encryption === true) {
                  for (let a = 0; a < date.length; a++) {
                    if (date[a][selectDatas[i].revisabilityName] && (selectDatas[i].type === 'text' || selectDatas[i].type === 'textarea') && typeof date[a][selectDatas[i].revisabilityName] !== 'string') {
                      date[a][selectDatas[i].revisabilityName] = JSON.stringify(date[a][selectDatas[i].revisabilityName])
                    }
                    if (selectDatas[i].type === 'date') date[a][selectDatas[i].revisabilityName] = timeSub(date[a][selectDatas[i].revisabilityName], selectDatas[i].dayType && selectDatas[i].dayType[0] ? selectDatas[i].dayType[0] : 'yyyy-MM-dd');
                    if (selectDatas[i].type === 'number') date[a][selectDatas[i].revisabilityName] = numberSub(date[a][selectDatas[i].revisabilityName], selectDatas[i].tempNumber);
                    if (selectDatas[i].type === 'file' || selectDatas[i].type === 'image') date[a][selectDatas[i].revisabilityName] = uploaderFun(date[a][selectDatas[i].revisabilityName]);
                    if (selectDatas[i].type === 'text') date[a][selectDatas[i].revisabilityName] = textSub(date[a][selectDatas[i].revisabilityName], 6);
                  }
                }
              }
            }
            let new_array = that.formatChange(date);//- 明细表表格配置格式转换
            // 开启了卡片模式
            if (datas.showWay === 4) {
              let canvasChildren = []
              if (datas.cardConfig && datas.cardConfig.configList) {
                canvasChildren = datas.cardConfig.configList[0].children
              }
              try {
                const _fromdatas = cloneDeep(new_array)
                user.forEach((item, i) => {
                  _fromdatas[i] = { ..._fromdatas[i], ...item }
                })
                new_array = await getConfig({
                  cardConfig: datas.cardConfig,
                  fromdatas: _fromdatas,
                  curpage: datas.curpage,
                  pagesize: datas.article,
                  appid: datas.appId
                })
              } catch (e) {
                console.log('数据合并失败', e)
              }
              if (user && user.length > 0) {
                try {
                  const getu = await getUserLists(user, canvasChildren)
                  for (let s = 0; s < new_array.length; s++) {
                    new_array[s] = { ...new_array[s], ...getu[s] }
                  }
                } catch (err) { console.log(err) }
              }
              console.log('查询刷新', new_array)
            }

            // 如果是无限滚动
            if (datas.loadSetting && datas.loadSetting === 'scroll' && datas.curpage > 1) {
              datas.fromdatas = datas.fromdatas.concat(new_array);
              if (user && user.length > 0) datas.user = datas.user.concat(user)
            } else {
              datas.fromdatas = new_array;
              if (user && user.length > 0) datas.user = user
            }
            datas.pageTotal = res.total;
            datas.fromdatasOriginal = originalData;
            that.changeFatoSon(datas);//- 显示更新
          }
          //- drawerClickStu存在时：说明当前客户端是表单扩大状态，不能对当前展示表单数据做处理
          if (this.drawer == true && !drawerClickStu) {
            //- 说明现在是在扩大层刷新表数据，表展示参数数据需要更新
            this.drawerDatasIndex = index;
            this.drawerDatas = JSON.parse(JSON.stringify(datas));
          }
        } else {
          //- 产品说第一次展示最新数据不显示提示
          that.$message({
            showClose: true,
            type: 'info',
            message: datas.reName + ',表格数据刷新失败'
          });

          that.changeFatoSon(datas);//- 显示更新
        }
      } catch (err) {
        datas.skeletonLoading = false;//- 骨架屏消失
      }
      // 如果是客户端打开，并且存在搜索则需要最大化
      this.initializeOpen(datas, index)
    },
    async systemLoad (datas, channel) {
      const that = this;
      const tocongigDatas = datas;
      const obj = {}
      if(tocongigDatas.api === 'gettopdashboard'){
        obj.pagesize = 25
      }
      else if(tocongigDatas.api === 'getapprovingoploglist'){
        obj.curpage = tocongigDatas.curpage
        obj.pagesize = 50
      }
      // 配置了日期筛选组件
      console.log("tocongigDatas==",tocongigDatas)
      if(tocongigDatas.rules.length > 0 && (tocongigDatas.api === 'getweekdashboard' || tocongigDatas.api === 'getmondashboard' || tocongigDatas.api === 'getdatedashboard')){
        if (tocongigDatas.toolbarConfig[0].FilterValue[0]) {
          obj.sdate = tocongigDatas.rules[0].value[0].split(' ')[0]
          obj.edate = tocongigDatas.rules[0].value[1].split(' ')[0]
          tocongigDatas.api = 'getdatedashboard'
        }
      }
      console.log("objobjobj==",obj)
      axiosBase(obj, "/api/" + tocongigDatas.api).then(async res => {
        datas.skeletonLoading = false;//- 骨架屏消失
        if (res.code === 0) {
          let date = res.data;
          console.log("data11==", JSON.parse(JSON.stringify(date)));
          // 数据实时使用情况时间戳转换格式
          if(tocongigDatas.api === 'getapprovingoploglist'){
            date = date.map(item => {
              const obj = cloneDeep(item)
              if (item.ctime) {
                obj.ctime = formatDate(item.ctime, 'yyyy-MM-dd hh:mm')
              }
              return obj
            })
          }
          else if(tocongigDatas.api === 'getweekdashboard'){
            date = Object.entries(date).map(([key, value]) => ({ key, value }))
          }
          else if(tocongigDatas.api === 'getmondashboard'){
            date = date.datelist.map(item => {
              const key = Object.keys(item)[0];
              const formattedKey = `${key.slice(0,4)}-${key.slice(4,6)}-${key.slice(6,8)}`;
              return {
                key: formattedKey,
                value: item[key]
              };
            });
          }
          else if(tocongigDatas.api === 'getdatedashboard'){
            date = Object.entries(date).map(([key, value]) => ({ 
              key, 
              value
            }));
          }
          else if(tocongigDatas.api === 'getorgcount' || tocongigDatas.api === 'getusercount'){
            date = {
                key: 'value',
                value: date
              }
          }
          else if(tocongigDatas.api === 'wlogs'){
            date = date.list
          }
          // 判断如果是对象，则变成数组格式
          if (!Array.isArray(date) && typeof date === 'object' && date !== null) {
            date = [date];
          }
          date = that.mergeFun(date);
          console.log("data22==",JSON.parse(JSON.stringify(date)));
          if(channel === 'form'){
            this.getSystemForm(date, res, tocongigDatas)
          }
          else if(channel === 'indicators'){
            this.getSystemIndicators(date,res, tocongigDatas)
          }
        } else {
          //- 产品说第一次展示最新数据不显示提示
          that.$message({
            showClose: true,
            type: 'info',
            message: datas.reName + ',数据刷新失败'
          });

          that.changeFatoSon(datas);//- 显示更新
        }
      })
    },
    // 页面初始化获取数据统计表（明细表）
    async getSystemForm(newData, res, datas){
      const that = this;
      let date = newData;
      let originalData = cloneDeep(res.data.originalDatas);
      const orj = {}
      if (datas.selectDatas && datas.selectDatas.length > 0) {
        for (const bb of datas.selectDatas) {
          const nn = bb.revisabilityName || bb.name
          orj[nn] = bb.type
        }
      }
      date = that.merge(date, orj);
      console.log('处理完的数据', JSON.parse(JSON.stringify(date)))
      if (datas.type === 'detailed') {
        //- 明细表
        let selectDatas = datas.selectDatas;
        if (selectDatas && selectDatas.length > 0 && date && date.length > 0) {
          for (let i = 0; i < selectDatas.length; i++) {
            if (selectDatas[i].type === 'date'
              || selectDatas[i].type === 'file'
              || selectDatas[i].type === 'image'
              || selectDatas[i].type === 'number' && selectDatas[i].tempNumber
              || selectDatas[i].type === 'text' && selectDatas[i].encryption && selectDatas[i].encryption === true) {
              for (let a = 0; a < date.length; a++) {
                if (date[a][selectDatas[i].revisabilityName] && (selectDatas[i].type === 'text' || selectDatas[i].type === 'textarea') && typeof date[a][selectDatas[i].revisabilityName] !== 'string') {
                  date[a][selectDatas[i].revisabilityName] = JSON.stringify(date[a][selectDatas[i].revisabilityName])
                }
                if (selectDatas[i].type === 'date') date[a][selectDatas[i].revisabilityName] = timeSub(date[a][selectDatas[i].revisabilityName], selectDatas[i].dayType && selectDatas[i].dayType[0] ? selectDatas[i].dayType[0] : 'yyyy-MM-dd');
                if (selectDatas[i].type === 'number') date[a][selectDatas[i].revisabilityName] = numberSub(date[a][selectDatas[i].revisabilityName], selectDatas[i].tempNumber);
                if (selectDatas[i].type === 'file' || selectDatas[i].type === 'image') date[a][selectDatas[i].revisabilityName] = uploaderFun(date[a][selectDatas[i].revisabilityName]);
                if (selectDatas[i].type === 'text') date[a][selectDatas[i].revisabilityName] = textSub(date[a][selectDatas[i].revisabilityName], 6);
              }
            }
          }
        }
        let new_array = that.formatChange(date);//- 明细表表格配置格式转换
        // 开启了卡片模式
        if (datas.showWay === 4) {
          try {
            const _fromdatas = cloneDeep(new_array)
            new_array = await getConfig({
              cardConfig: datas.cardConfig,
              fromdatas: _fromdatas,
              curpage: datas.curpage,
              pagesize: datas.article,
              appid: datas.appId
            })
          } catch (e) {
            console.log('数据合并失败', e)
          }
          console.log('查询刷新', new_array)
        }

        // 如果是无限滚动
        if (datas.loadSetting && datas.loadSetting === 'scroll' && datas.curpage > 1) {
          datas.fromdatas = datas.fromdatas.concat(new_array);
          // if (user && user.length > 0) datas.user = datas.user.concat(user)
        } else {
          datas.fromdatas = new_array;
          // if (user && user.length > 0) datas.user = user
        }
        datas.pageTotal = res.total;
        datas.fromdatasOriginal = originalData;
        that.changeFatoSon(datas);//- 显示更新
      }
      //- drawerClickStu存在时：说明当前客户端是表单扩大状态，不能对当前展示表单数据做处理
      if (this.drawer == true) {
        //- 说明现在是在扩大层刷新表数据，表展示参数数据需要更新
        // this.drawerDatasIndex = index;
        this.drawerDatas = JSON.parse(JSON.stringify(datas));
      }
    },
    // 页面初始化获取数据统计表（可视化）
    async getSystemIndicators(newData, res, item){
      let date = newData
      if (JSON.stringify(date) === '[{}]') {
        item.totalValue = null;
        item.tableData = [];
      } else {

        //- 获取总值
        let cols = res.data.cols;
        let list = res.data.list;
        var totalValue = 0;

        // 特殊加料
        let row = item.row;
        let column = item.column;
        if (row && row.length > 0 && date && date.length > 0) {
          for (let i = 0; i < row.length; i++) {
            const rowItem = row[i]
            if ((row[i].type === 'date' || row[i].type === 'number') && row[i].format) {
              const rowName = (rowItem.revisabilityName || rowItem.name)
              // const rowName = (rowItem.revisabilityName || rowItem.name) + '显示格式'
              for (let a = 0; a < date.length; a++) {
                date[a][rowItem.revisabilityName || rowItem.name] = date[a][rowName] || date[a][rowName] === 0 ? date[a][rowName] : date[a][rowName + '显示格式']
                if (row[i].format === 'yyyy-MM-dd EEE' && date[a][rowItem.revisabilityName || rowItem.name]) {
                  date[a][rowItem.revisabilityName || rowItem.name] = (date[a][rowItem.revisabilityName || rowItem.name]) + ' 星期' + getWeek(date[a][rowItem.revisabilityName || rowItem.name])
                } else if (row[i].format === 'EEE' && date[a][rowItem.revisabilityName || rowItem.name]) {
                  date[a][rowItem.revisabilityName || rowItem.name] = '星期' + getWeek(date[a][rowItem.revisabilityName || rowItem.name])
                }
                // date[a][rowItem.revisabilityName || rowItem.name] = date[a][rowName]
              }
            }
          }
        }
        if (column && column.length > 0 && date && date.length > 0) {
          for (let i = 0; i < column.length; i++) {
            const columnItem = column[i]
            const columnName = (columnItem.revisabilityName || columnItem.name)
            // const columnName = (columnItem.revisabilityName || columnItem.name) + '显示格式'
            for (let a = 0; a < date.length; a++) {
              date[a][columnItem.revisabilityName || columnItem.name] = date[a][columnName] || date[a][columnName] === 0 ? date[a][columnName] : date[a][columnName + '显示格式']
              if (column[i].format === 'yyyy-MM-dd EEE' && date[a][columnItem.revisabilityName || columnItem.name]) {
                date[a][columnItem.revisabilityName || columnItem.name] = (date[a][columnItem.revisabilityName || columnItem.name]) + ' 星期' + getWeek(date[a][columnItem.revisabilityName || columnItem.name])
              } else if (column[i].format === 'EEE' && date[a][columnItem.revisabilityName || columnItem.name]) {
                date[a][columnItem.revisabilityName || columnItem.name] = '星期' + getWeek(date[a][columnItem.revisabilityName || columnItem.name])
              }
              // date[a][columnItem.revisabilityName || columnItem.name] = date[a][columnName]
            }
          }
        }
        console.log('加料完毕', date)
        if (item.chartType == "indicators") {
          if (item.row.length == 0) {
            //- 单行指标图显示总数
            let value = this.mergeFun(list);
            for (let i in value[0]) {
              if (i !== 'index') {
                totalValue = value[0][i];
              }
            }
          } else if (item.row.length > 0) {
            //- 双行指标图显示总数
            for (let i in cols) {
              if (i !== 'index') {
                totalValue = cols[i];
              }
            }

          }
        }
        console.log('判断类型', item, item.chartType, item.chartType === 'treemap')
        // 地图另外来
        if (item.chartType === 'gdMap') {
          item.tableData = mapClient({
            date: date,
            row: item.row,
            column: item.column,
            summary: item.summary,
            config: item.gdMapConfig
          })
          console.log('地图的转码', item.tableData)
        } else if (item.chartType === 'treemap') {
          item.tableData = treemapClient({
            list: date,
            row: item.row,
            column: item.column,
            summary: item.summary,
            config: item.gdMapConfig,
            cols: res.data.cols
          })
        } else {
          //- 表格数据
          if (item.row.length == 0) {
            item.tableData = [];
          } else {
            // 有列字段另说
            if (item.column && item.column.length > 0) {
              item.tableData = visualizationClient({
                row: item.row,
                column: item.column,
                summary: item.summary,
                date: this.seriesType==='name'?list:date,
                type: item.chartType,
                seriesType:item.seriesType
              })
              console.log('可视化有列字段，另说', item.tableData, item)
            } else {
              item.tableData = this.valueRemould(date, item.row, item.summary,item.seriesType,item);  // 结果集
            }
          }
        }
        item.totalValue = totalValue;
      }
      item.pageTotal = res.total;
      item.pages = res.pages;
      if (res.user) item.user = res.user

      this.$set(this.layout, this.indicatorsIdx, item);
      //- drawerClickStu存在时：说明当前客户端是表单扩大状态，不能对当前展示表单数据做处理
      if (this.drawer == true) {
        //- 说明现在是在扩大层刷新表数据，表展示参数数据需要更新
        this.drawerDatasIndex = this.indicatorsIdx;
        this.drawerDatas = item;
      }
    },
    //- 指标图/饼图-----客户端请求表数据（放置顶层）
    //- i 下标 item 配置 ref 是否刷新缓存 1为刷新缓存,0为不刷新获取分页数据
    async getIndicatorsDetailsTable (i, item, ref, drawerClickStu) {
      this.layout[i] = item
      this.layout[i].skeletonLoading = true;//- 开启骨架屏
      // 系统数据表
      if(item.isSource === 11){
        this.indicatorsIdx = i
        this.systemLoad(item, 'indicators')        
        return
      }
      let mergeRules = [];
      if (item.rules && item.rules != undefined) {
        //- 外置筛选组件的筛选规则
        mergeRules = mergeRules.concat(item.rules);
      }
      if (item.relevanceRules && item.relevanceRules != undefined) {
        //- 表单关联表单的筛选规则
        mergeRules = mergeRules.concat(item.relevanceRules);
      }
      let submitDatas = {
        approvalDashboardId: this.$parent.submitDataAlls.approvalDashboardId,//- 仪表盘id
        index: i,//- 仪表盘索引
        value: JSON.stringify(mergeRules),//- 筛选组件提交的筛选值
        curpage: item.devCurpage,//- 当前页 (如果是汇总，该值传0)
        pagesize: item.devArticle,//- 每页条数 (如果是汇总，该值传0)
        export: '',//- 是否导出数据,1为导出，其它不导出
        ref: ref,
        querys: item.querys ? item.querys : '',//- 仪表盘验证过滤数据
      }
      // 从空间进入，需要传空间id
      if(this.isSpace){
        let spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
        submitDatas.spaceid = spaceId;
      }
      else if (this.isUpace) {
        let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        submitDatas.upaceid = upaceId
      }
      let customDataList = this.$store.state.dashboardCustomDataObj[this.$parent.submitDataAlls.approvalDashboardId] || this.$store.state.dashboardCustomData
      if (customDataList) {
        if (this.draggable) {
          customDataList = await setConfigCustomData(cloneDeep(customDataList))
        }
        // 存在$就是自定义的变量
        submitDatas.customData = setCustomData(customDataList)
      }
      if (item.isSource === 2 && Array.isArray(item.variableconfig) && item.variableconfig.length > 0) {
        const customData = submitDatas.customData ? cloneDeep(submitDatas.customData) : {}
        item.variableconfig.forEach(item => {
          customData[item.name] = item.value
        })
        submitDatas.customData = customData
      }
      if (this.customDeskInfo && this.customDeskInfo.token) {
        submitDatas.accesstoken = this.customDeskInfo.token
      }
      try {
        const res = await apiUpateview(submitDatas, item.type)
        console.log('指标图返回', res)
        this.layout[i].skeletonLoading = false;//- 骨架屏消失
        if (res.code === 0) {
          let date = res.data.list;
          date = date.map(({ ...rest }) => rest);
          if (item.reverseOrder) date = date.reverse()
          date = this.mergeFun(date);
          if (JSON.stringify(date) === '[{}]') {
            item.totalValue = null;
            item.tableData = [];
          } else {

            //- 获取总值
            let cols = res.data.cols;
            let list = res.data.list;
            var totalValue = 0;

            // 特殊加料
            let row = item.row;
            let column = item.column;
            if (row && row.length > 0 && date && date.length > 0) {
              for (let i = 0; i < row.length; i++) {
                const rowItem = row[i]
                if ((row[i].type === 'date' || row[i].type === 'number') && row[i].format) {
                  const rowName = (rowItem.revisabilityName || rowItem.name)
                  // const rowName = (rowItem.revisabilityName || rowItem.name) + '显示格式'
                  for (let a = 0; a < date.length; a++) {
                    date[a][rowItem.revisabilityName || rowItem.name] = date[a][rowName] || date[a][rowName] === 0 ? date[a][rowName] : date[a][rowName + '显示格式']
                    if (row[i].format === 'yyyy-MM-dd EEE' && date[a][rowItem.revisabilityName || rowItem.name]) {
                      date[a][rowItem.revisabilityName || rowItem.name] = (date[a][rowItem.revisabilityName || rowItem.name]) + ' 星期' + getWeek(date[a][rowItem.revisabilityName || rowItem.name])
                    } else if (row[i].format === 'EEE' && date[a][rowItem.revisabilityName || rowItem.name]) {
                      date[a][rowItem.revisabilityName || rowItem.name] = '星期' + getWeek(date[a][rowItem.revisabilityName || rowItem.name])
                    }
                    // date[a][rowItem.revisabilityName || rowItem.name] = date[a][rowName]
                  }
                }
              }
            }
            if (column && column.length > 0 && date && date.length > 0) {
              for (let i = 0; i < column.length; i++) {
                const columnItem = column[i]
                const columnName = (columnItem.revisabilityName || columnItem.name)
                // const columnName = (columnItem.revisabilityName || columnItem.name) + '显示格式'
                for (let a = 0; a < date.length; a++) {
                  date[a][columnItem.revisabilityName || columnItem.name] = date[a][columnName] || date[a][columnName] === 0 ? date[a][columnName] : date[a][columnName + '显示格式']
                  if (column[i].format === 'yyyy-MM-dd EEE' && date[a][columnItem.revisabilityName || columnItem.name]) {
                    date[a][columnItem.revisabilityName || columnItem.name] = (date[a][columnItem.revisabilityName || columnItem.name]) + ' 星期' + getWeek(date[a][columnItem.revisabilityName || columnItem.name])
                  } else if (column[i].format === 'EEE' && date[a][columnItem.revisabilityName || columnItem.name]) {
                    date[a][columnItem.revisabilityName || columnItem.name] = '星期' + getWeek(date[a][columnItem.revisabilityName || columnItem.name])
                  }
                  // date[a][columnItem.revisabilityName || columnItem.name] = date[a][columnName]
                }
              }
            }
            console.log('加料完毕', date)
            if (item.chartType == "indicators") {
              if (item.row.length == 0) {
                //- 单行指标图显示总数
                let value = this.mergeFun(list);
                for (let i in value[0]) {
                  if (i !== 'index') {
                    totalValue = value[0][i];
                  }
                }

              } else if (item.row.length > 0) {
                //- 双行指标图显示总数
                for (let i in cols) {
                  if (i !== 'index') {
                    totalValue = cols[i];
                  }
                }

              }
            }
            console.log('判断类型', item, item.chartType, item.chartType === 'treemap')
            // 地图另外来
            if (item.chartType === 'gdMap') {
              item.tableData = mapClient({
                date: date,
                row: item.row,
                column: item.column,
                summary: item.summary,
                config: item.gdMapConfig
              })
              console.log('地图的转码', item.tableData)
            } else if (item.chartType === 'treemap') {
              item.tableData = treemapClient({
                list: date,
                row: item.row,
                column: item.column,
                summary: item.summary,
                config: item.gdMapConfig,
                cols: res.data.cols
              })
            } else {
              //- 表格数据
              if (item.row.length == 0) {
                item.tableData = [];
              } else {
                // 有列字段另说
                if (item.column && item.column.length > 0) {
                  item.tableData = visualizationClient({
                    row: item.row,
                    column: item.column,
                    summary: item.summary,
                    date: this.seriesType==='name'?list:date,
                    type: item.chartType,
                    seriesType:item.seriesType
                  })
                  console.log('可视化有列字段，另说', item.tableData, item)
                } else {
                  item.tableData = this.valueRemould(date, item.row, item.summary,item.seriesType, item);  // 结果集
                }
              }
            }
            item.totalValue = totalValue;
          }
          item.pageTotal = res.total;
          item.pages = res.pages;
          if (res.user) item.user = res.user
          
          this.layout[i] = item;
          //- drawerClickStu存在时：说明当前客户端是表单扩大状态，不能对当前展示表单数据做处理
          if (this.drawer == true && !drawerClickStu) {
            //- 说明现在是在扩大层刷新表数据，表展示参数数据需要更新
            this.drawerDatasIndex = i;
            this.drawerDatas = item;
          }
        } else {
          this.$message({
            showClose: true,
            type: 'info',
            message: item.reName + ',表格数据刷新失败'
          });
        }
      } catch (err) {
        this.layout[i].skeletonLoading = false;//- 骨架屏消失
      }
      item.skeletonLoading = false

      this.initializeOpen(item, i)
    },
    //- 汇总表-----客户端请求表数据（放置顶层）
    //- i 下标 item 配置 ref 是否刷新缓存 1为刷新缓存,0为不刷新获取分页数据
    async getSummaryTable (i, item, ref, drawerClickStu) {
      this.layout[i].skeletonLoading = true;//- 开启骨架屏
      item.tableData = []
      this.layout[i] = item
      let mergeRules = [];
      if (item.rules && item.rules != undefined) {
        //- 外置筛选组件的筛选规则
        mergeRules = mergeRules.concat(item.rules);
      }
      if (item.relevanceRules && item.relevanceRules != undefined) {
        //- 表单关联表单的筛选规则
        mergeRules = mergeRules.concat(item.relevanceRules);
      }
      // 对筛选组件筛选值做过滤
      let contrastVal = []
      let isBasis = false
      if (item.toolbarConfig && item.toolbarConfig.length > 0) {
        const ss = toolbarSearch(item.toolbarConfig, mergeRules)
        mergeRules = ss.list
        contrastVal = ss.contrast
        isBasis = ss.isBasis
      }

      let submitDatas = {
        approvalDashboardId: this.$parent.submitDataAlls.approvalDashboardId,//- 仪表盘id
        index: i,//- 仪表盘索引
        value: JSON.stringify(mergeRules),//- 筛选组件提交的筛选值
        curpage: item.devCurpage,//- 当前页 (如果是汇总，该值传0)
        pagesize: item.devArticle,//- 每页条数 (如果是汇总，该值传0)
        export: '',//- 是否导出数据,1为导出，其它不导出
        ref: ref,
        querys: item.querys ? item.querys : '',//- 仪表盘验证过滤数据
        query: item.query ? item.query : '',//- 仪表盘排序
        order: item.order ? item.order : '',//- 仪表盘输入框查询
      }
      // 从空间进入，需要传空间id
      if(this.isSpace){
        let spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
        submitDatas.spaceid = spaceId;
      }
      else if (this.isUpace) {
        let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        submitDatas.upaceid = upaceId
      }
      let customDataList = this.$store.state.dashboardCustomDataObj[this.id] || this.$store.state.dashboardCustomData
      if (customDataList) {
        if (this.draggable) {
          customDataList = await setConfigCustomData(cloneDeep(customDataList))
        }
        // 存在$就是自定义的变量
        submitDatas.customData = setCustomData(customDataList)
      }
      if (item.isSource === 2 && Array.isArray(item.variableconfig) && item.variableconfig.length > 0) {
        const customData = submitDatas.customData ? cloneDeep(submitDatas.customData) : {}
        item.variableconfig.forEach(item => {
          customData[item.name] = item.value
        })
        submitDatas.customData = customData
      }
      if (this.customDeskInfo && this.customDeskInfo.token) {
        submitDatas.accesstoken = this.customDeskInfo.token
      }
      try {
        const res = await apiUpateview(submitDatas)
        console.log('汇总查询结果', res)
        if (res.code === 0) {
          // let add_table = JSON.parse(JSON.stringify(res.data.list));

          let add_table = this.changeSummary(JSON.parse(JSON.stringify(res.data.list)), JSON.parse(JSON.stringify(item.column)));

          let date = this.mergeFun(res.data.list);
          // 特殊加料
          let row = item.row;
          let column = item.column;
          if (row && row.length > 0 && date && date.length > 0) {
            for (let i = 0; i < row.length; i++) {
              const rowItem = row[i]
              if ((row[i].type === 'date' || row[i].type === 'number') && row[i].format) {
                const rowName = (rowItem.revisabilityName || rowItem.name)
                // const rowName = (rowItem.revisabilityName || rowItem.name) + '显示格式'
                for (let a = 0; a < date.length; a++) {
                  date[a][rowItem.revisabilityName || rowItem.name] = date[a][rowName] || date[a][rowName] === 0 ? date[a][rowName] : date[a][rowName + '显示格式']
                  // date[a][rowItem.revisabilityName || rowItem.name] = date[a][rowName]
                  if (row[i].format === 'yyyy-MM-dd EEE' && date[a][rowItem.revisabilityName || rowItem.name]) {
                    date[a][rowItem.revisabilityName || rowItem.name] = (date[a][rowItem.revisabilityName || rowItem.name]) + ' 星期' + getWeek(date[a][rowItem.revisabilityName || rowItem.name])
                  } else if (row[i].format === 'EEE' && date[a][rowItem.revisabilityName || rowItem.name]) {
                    date[a][rowItem.revisabilityName || rowItem.name] = '星期' + getWeek(date[a][rowItem.revisabilityName || rowItem.name])
                  }
                }
              }
            }
          }
          if (column && column.length > 0 && date && date.length > 0) {
            for (let i = 0; i < column.length; i++) {
              const columnItem = column[i]
              const columnName = (columnItem.revisabilityName || columnItem.name)
              // const columnName = (columnItem.revisabilityName || columnItem.name) + '显示格式'
              for (let a = 0; a < date.length; a++) {
                date[a][columnItem.revisabilityName || columnItem.name] = date[a][columnName] || date[a][columnName] === 0 ? date[a][columnName] : date[a][columnName + '显示格式']
                // date[a][columnItem.revisabilityName || columnItem.name] = date[a][columnName]
                if (column[i].format === 'yyyy-MM-dd EEE' && date[a][columnItem.revisabilityName || columnItem.name]) {
                  date[a][columnItem.revisabilityName || columnItem.name] = (date[a][columnItem.revisabilityName || columnItem.name]) + ' 星期' + getWeek(date[a][columnItem.revisabilityName || columnItem.name])
                } else if (column[i].format === 'EEE' && date[a][columnItem.revisabilityName || columnItem.name]) {
                  date[a][columnItem.revisabilityName || columnItem.name] = '星期' + getWeek(date[a][columnItem.revisabilityName || columnItem.name])
                }
              }
            }
          }

          let table = serverPageSummary({...res.data, list: date}, item.column, item.row, item.summary, item.isSummary, { curpage: res.curpage, pages: res.pages }, { contrastVal: contrastVal, pool: item.poolConfig, isPool: item.contrast, isBasis: isBasis });
          // let table = serverPageSummary(res.data, item.column, item.row, item.summary, item.isSummary, { curpage: res.curpage, pages: res.pages });

          console.log('查看汇总结果', table, res.data)
          let tableList = JSON.parse(JSON.stringify(table.list));
          // 排序一下
          let { info } = getGenerateTableTopTwo(date, item.row, item.column, item.summary, item.isSummary, item.poolConfig, [], item.contrast);
          
          if (Array.isArray(info) && info.length === tableList.length) {
            const query = {}
            item.row.forEach(val => { query[val.name] = '' })
            const newTableList = []
            info.forEach(data => {
              const _arr = tableList.find(iten => {
                let flag = true
                const _query = cloneDeep(query)
                for (const key in _query) {
                  if (data[key] != iten[key]) {
                    flag = false
                    break
                  }
                }
                return flag
              })
              if (_arr) {
                newTableList.push(_arr)
              }
            })
            tableList = newTableList
          }
          console.log('之前', JSON.parse(JSON.stringify(add_table)))
          // let concatObject = add_table.map((item, index) => {
          //   // 删掉有 特殊字符的
          //   for (const i in item) {
          //     if (i.includes('\u0001')) delete item[i]
          //   }
          //   return { ...item, ...tableList[index] };
          // })
          let concatObject = tableList.map((item, index) => {
            // 删掉有 特殊字符的
            for (const i in item) {
              if (i.includes('\u0001')) delete item[i]
            }
            if (item.isPool) {
              return item
            } else {
              return { ...add_table[index], ...item };
            }
          })

          item.topCount = table.topCount;//- 记录除汇总列以外的列数，为点击汇总表格点击事件做准备
          item.defaultMerge = table.top;
          item.partitionList = table.partitionList || []
          this.closeButton(item.i)

          const toolbarConfig = item.toolbarConfig
          const summaryList = getShowFiled(toolbarConfig || [], JSON.parse(JSON.stringify(item.summary)))
          // item.merge = table.top;
          let top = table.top
          if (summaryList.length !== item.summary.length) {
            let row = 1
            if (item.column && item.column.length === 0) {
              row = item.row.length
            }
            const first = table.top.slice(0, row)
            top = getHidenList(table.top.slice(row, table.top.length), summaryList)
            top.unshift(...first)
          }
          if (item.rowWidthConfig && item.rowWidthConfig === 'adaptive') {
            // 获取除第一列外的其他总列数
            let sCount = 0
            const getSumCount = (arr) => {
              for (const i of arr) {
                if (i.ind) {
                  sCount += 1
                } else if (i.children && i.children.length > 0) {
                  getSumCount(i.children)
                }
              }
            }
            let sArr = JSON.parse(JSON.stringify(top))
            sArr = sArr.slice(1, sArr.length)
            getSumCount(sArr)
            item.sumCount = sCount
          }
          item.merge = top;
          item.pageTotal = res.total;
          item.pages = res.pages;
          if (item.isSummary == 1 && item.pages === item.devCurpage && res.pages !== 1) {
            //- 是自动汇总
            // item.tableData = concatObject.concat(beifengArr);  // 结果集
            item.tableData = concatObject  // 结果集
          } else {
            //- 否自动汇总
            item.tableData = concatObject;
          }

          item.tableMerge = this.tableMerge(table.list, item);
          this.layout[i].skeletonLoading = false;//- 骨架屏消失
          item.skeletonLoading = false
          // 联系人数据
          if (res.user) item.user = res.user

          this.layout[i] = item;
          //- drawerClickStu存在时：说明当前客户端是表单扩大状态，不能对当前展示表单数据做处理
          if (this.drawer == true && !drawerClickStu) {
            //- 说明现在是在扩大层刷新表数据，表展示参数数据需要更新
            this.drawerDatasIndex = i;
            this.drawerDatas = JSON.parse(JSON.stringify(item));
          }
        } else {

          this.$message({
            showClose: true,
            type: 'info',
            message: item.reName + ',表格数据刷新失败'
          });
          this.layout[i].skeletonLoading = false;//- 骨架屏消失
        }
      } catch (error) {
        this.layout[i].skeletonLoading = false;//- 骨架屏消失
      }
      this.initializeOpen(item, i)
    },

    // 把数据里面的联系人数据提取出来
    getUserList (date) {
      let arr = [];
      for (let i = 0; i < date.length; i++) {
        let str = {};
        for (let e in date[i]) {
          if (typeof date[i][e] === 'object') {
            let retStr = this.retUser(date[i][e], e);
            str = Object.assign(str, retStr);
          }
        }
        arr.push(str);
      }
      return arr;
    },
    retUser (data, name) {
      let strObj = {};
      // 区分 [] 和 {}
      if (Array.isArray(data)) {
        if (data[0] && data[0].realname) {
          strObj[name] = data;
        }
      } else {
        if (data.realname) {
          strObj[name] = data;
        } else {
          for (let i in data) {
            if (typeof data[i] === 'object') {
              let retStrs = this.retsule(data[i], (name + '.' + i));
              strObj = Object.assign(strObj, retStrs);
            }
          }
        }
      }
      return strObj;
    },
    // 判断是否需要初始化打开
    initializeOpen (datas, index) {
      if (!this.isFrontEnd && this.$route.query.search && !this.$route.query.showSearch) {
        this.handle({
          status: 'enlarge',
          item: datas,
          index: index
        })
      }
    },
    changeSummary (data, column) {
      let columnLength = column.length;
      if (data && data.length > 0) {
        data.forEach(item => {
          for (var j in item) {

            let keyName = j.split(/\1{1}/g);
            if ((keyName.length - 1) == columnLength) {
              column.forEach((item2, i2) => {
                // item[item2.name] = keyName[i2];
                if (!item[item2.name]) {
                  let newArray = [];
                  newArray.push(keyName[i2]);
                  item[item2.name] = newArray;
                } else {
                  let array = item[item2.name];
                  if (keyName[i2] != '' && array.indexOf(keyName[i2]) == -1) {
                    array = array.push(keyName[i2]);
                  }

                }

              })

            }
          }
        })
      }
      return data;

    },
    //- 在关联表单功能时，点击触发需要判断当前不是后台界面和不是扩大区域功能时的场景
    panduanScene () {
      // || this.drawer === true
      if (this.isFrontEnd === true) {
        return false

      } else {
        return true
      }

    },
    //- 寻找当前表单关联功能触发后的对应表单(清除关联)
    /*****注意：drawerClickStu存在时：说明当前客户端是表单扩大状态，，需要对数据特殊处理 */
    changeRelevanceFunClose (val, drawerClickStu) {
      const that = this;
      let id = val.id;
      let layout = that.layout;
      if (that.panduanScene() === false) {
        //- 说明该状态不行数据关联
        return
      }

      //- 正常客户端流程
      //- 寻找当前表单关联功能触发后的对应表单
      let findIndex = layout.findIndex(item => {
        return item.i === id;
      })
      if (findIndex != -1 && layout[findIndex].relevance && layout[findIndex].relevance.length > 0) {
        let relevance = layout[findIndex].relevance;
        relevance.forEach(item => {
          setTimeout(() => {
            let changeIndex = layout.findIndex(item2 => { return item2.i === item.id })
            if (changeIndex != -1) {
              let relevanceRules = layout[changeIndex].relevanceRules;
              if (relevanceRules && relevanceRules.length > 0) {
                let canIndex = relevanceRules.findIndex(item3 => { return item3.triggerId === id });
                if (canIndex != -1) {
                  //- 修改目标文件数据
                  relevanceRules[canIndex].datas.forEach(item4 => {
                    if (val.value.length === 0) {
                      item4.value = [];
                    } else {
                      let submitValue = val.value;
                      if (!submitValue[item4.matchName]) {
                      // if (!submitValue[item4.fieldName]) {
                        item4.value = [];

                      } else {
                        item4.value[0] = JSON.parse(JSON.stringify(submitValue[item4.matchName]))
                        // item4.value[0] = JSON.parse(JSON.stringify(submitValue[item4.fieldName]))
                      }

                    }

                  })

                }
              }

              if (layout[changeIndex].type === "detailed") {
                //- 明细
                layout[changeIndex].curpage = 1;//- 页数还原
                that.getNewFromDatas(changeIndex, layout[changeIndex], drawerClickStu)
              } else if (layout[changeIndex].type === "summary") {
                //- 汇总
                layout[changeIndex].devCurpage = 1;//- 页数还原
                that.getSummaryTable(changeIndex, layout[changeIndex], 1, drawerClickStu)
              } else if (layout[changeIndex].type === "indicatorsBread") {
                //- 指标图
                layout[changeIndex].devCurpage = 1;//- 页数还原
                that.getIndicatorsDetailsTable(changeIndex, layout[changeIndex], 1, drawerClickStu)
              }
            }

          }, 100)

        })

        //- 表单扩大区域内容选择后回填源表单
        //- 重新选择选中显示效果
        if (layout[findIndex].type === "indicatorsBread") {
          //- 双行指标图
          // that.$refs['indicatorsRefs_'+id][0].selectIndex = val.selectIndex;
          layout[findIndex].selectIndex = val.selectIndex;
          layout[findIndex].selectPage = val.selectPage;//- 当前分页的页数
          if (that.drawer == true) {
            that.drawerDatas.selectIndex = val.selectIndex;
            that.drawerDatas.selectPage = val.selectPage;//- 当前分页的页数
            that.$refs.drawerRefs.$forceUpdate();
          }

        } else if (layout[findIndex].type === "summary") {
          // that.$refs['sumTableRefs_'+id][0].selectIndex = val.selectIndex;
          layout[findIndex].selectRow = val.selectRow;
          layout[findIndex].selectCloum = val.selectCloum;
          layout[findIndex].selectPage = val.selectPage;//- 当前分页的页数
          if (that.drawer == true) {
            that.drawerDatas.selectRow = val.selectRow;
            that.drawerDatas.selectCloum = val.selectCloum;
            that.drawerDatas.selectPage = val.selectPage;//- 当前分页的页数
            that.$refs.drawerRefs.$forceUpdate();

          }

        }
      }

    },
    //- 寻找当前表单关联功能触发后的对应表单
    /*****注意：drawerClickStu存在时：说明当前客户端是表单扩大状态，，需要对数据特殊处理 */
    changeRelevanceFun (val, drawerClickStu) {
      console.log('点击下来', val,drawerClickStu)
      const that = this;
      let id = val.id;
      let layout = that.layout;
      if (that.panduanScene() === false) {
        //- 说明该状态不行数据关联
        return
      }

      //- 正常客户端流程
      //- 寻找当前表单关联功能触发后的对应表单
      let findIndex = layout.findIndex(item => {
        return item.i === id;
      })
      if (findIndex != -1 && layout[findIndex].relevance && layout[findIndex].relevance.length > 0) {
        let relevance = layout[findIndex].relevance;
        console.log('查询到当前对应表单', relevance, typeof relevance)
        // 弹出新窗口选择
        const newWindow = []
        relevance.forEach(item => {
          console.log('当前遍历配置', item)
          // 自定的是否可以继续处理(当前逻辑弃用，欧说不作为验证使用 24-12-13)
          // if (item.customize) {
          //   for (const s of item.customize) {
          //     if ((s.value || s.value === 0) && val.value[s.name] != s.value) {
          //       console.log('自定义条件不符合，则不处理')
          //       return
          //     }
          //   }
          // }

          setTimeout(async () => {
            let changeIndex = layout.findIndex(item2 => { return item2.i === item.id })
            if (changeIndex !== -1) {
              let relevanceRules = layout[changeIndex].relevanceRules;
              if (relevanceRules && relevanceRules.length > 0) {
                let canIndex = relevanceRules.findIndex(item3 => { return item3.triggerId === id });
                if (canIndex != -1) {
                  //- 修改目标文件数据
                  const datas = relevanceRules[canIndex].datas
                  console.log('修改目标文件数据', datas, layout[changeIndex])
                  for (let i = 0; i < datas.length; i++) {
                    const item4 = datas[i]
                    // 自定义配置处理(有type的就是自定义的)
                    console.log('当前值', val.value[item4.fieldName])
                    let userVal = val.value[item4.matchName]
                    // let userVal = val.value[item4.fieldName]
                    if (item4.type && item4.type === 'relation-user' && typeof val.user[item4.matchName] === "object") {
                      // 汇总列字段配置联系人是没有用户 id 的
                      if (item4.format === 'userId' || item4.format === 'realname') {
                        userVal = val.user[item4.matchName][item4.format]
                      } else {
                        const user = await this.getUserInfo(val.user[item4.matchName].userId)
                        userVal = user[item4.format]
                      }
                    } else if (item4.type && item4.type === 'date') {
                      userVal = await this.getTime(userVal, item4.format)
                    }
                    if (val.value.length === 0) {
                      item4.value = [];
                    } else {
                      let submitValue = val.value;
                      if (!submitValue[item4.matchName] && submitValue[item4.matchName] !== 0) {
                        item4.value = [];
                      } else {
                        item4.value[0] = userVal
                      }
                    }
                    datas[i] = item4
                  }
                  relevanceRules[canIndex].datas = datas
                }
              }
      console.log('去查询', relevanceRules)
              // 判断如果 是本表并且仅传参 则直接走以下逻辑(旧数据也走以下)
              if (!item.link || (item.open === 1 && item.link === 1)) {
                if (layout[changeIndex].type === "detailed") {
                  //- 明细
                  layout[changeIndex].curpage = 1;//- 页数还原
                  that.getNewFromDatas(changeIndex, layout[changeIndex], drawerClickStu)
                } else if (layout[changeIndex].type === "summary") {
                  //- 汇总
                  layout[changeIndex].devCurpage = 1;//- 页数还原
                  that.getSummaryTable(changeIndex, layout[changeIndex], 1, drawerClickStu)
                } else if (layout[changeIndex].type === "indicatorsBread") {
                  //- 指标图
                  layout[changeIndex].devCurpage = 1;//- 页数还原
                  that.getIndicatorsDetailsTable(changeIndex, layout[changeIndex], 1, drawerClickStu)
                }
              }
            }

          }, 10)
          if (item.open !== 1) {
            item.value = val.value
            if (val.user) item.user = val.user
            newWindow.push(item)
          }
        })

        //- 表单扩大区域内容选择后回填源表单
        //- 重新选择选中显示效果
        if (layout[findIndex].type === "indicatorsBread") {
          //- 双行指标图
          layout[findIndex].selectPage = val.selectPage;//- 当前分页的页数
          if (that.drawer == true) {
            that.drawerDatas.selectPage = val.selectPage;//- 当前分页的页数
            that.$refs.drawerRefs.$forceUpdate();
          }

        } else if (layout[findIndex].type === "summary") {
          layout[findIndex].selectRow = val.selectRow;
          layout[findIndex].selectCloum = val.selectCloum;
          layout[findIndex].selectPage = val.selectPage;//- 当前分页的页数
          if (that.drawer == true) {
            that.drawerDatas.selectRow = val.selectRow;
            that.drawerDatas.selectCloum = val.selectCloum;
            that.drawerDatas.selectPage = val.selectPage;//- 当前分页的页数
            that.$refs.drawerRefs.$forceUpdate();

          }

        }

        // newWindow 不等于空，并且 relevance 数据大于一个，则弹出
        if (newWindow.length === 1 && relevance.length === 1) {
          // 只有一个，不选择， 直接走
          setTimeout(() => {
            this.goOpen(newWindow[0])
          }, 11)
        } else if (newWindow.length > 0) {
          // 打开选择弹窗
          this.jumpArr = newWindow
          this.isJump = true
        }

      }
    },
    // 删除对标数据
    delLastrecentdata (item, type) {
      this.$confirm('确定要删除？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        // 删除
        const str = await this.getField(item, type)
        const obj = {
          type: item.appIid === 18 ? 0 : 1,
          approvalId: str.approvalId
        }
        if (str.search) {
          obj.query = {}
          for (const s in str.search) {
            // 空数据不管
            if (str.search[s] || str.search[s] === 0) {
              const val = str.search[s]
              if (Array.isArray(val)) {
                obj.query[s] = val
              } else {
                obj.query[s] = [val]
              }
              // 做一次空置去除
              obj.query[s] = obj.query[s].filter(its => its || its === 0)
            }
          }
        }
        if (obj.query) obj.query = JSON.stringify(obj.query)
        // console.log('拼接完毕', obj)
        const res = await deletelastrecentdata(obj).catch(err => { console.log('删除错误', err) })
        if (res.code === 0) {
          // 刷新明细
          const index = this.layout.findIndex(its => its.i === item.id)
          if (index !== -1) {
            this.getNewFromDatas(index, this.layout[index], this.drawer)
          }
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          });
        }
      })
    },
    // 根据打开方式打开
    async goOpen (item, type) {
      console.log('跳转接收', item)
      // 如果是站内并且设置了删除
      if (item.link === 2 && item.datatype === 1 && (item.appIid === 18 || item.appIid === 17)) {
        this.delLastrecentdata(item, type)
        return
      }
      if (item.open === 2) {
        // 弹窗，如果是本表组建就直接扩大打开
        if (item.link === 1) {
          // 找到对应扩大打开
          const i = this.layout.findIndex(its => its.i === item.id)
          if (i !== -1) {
            const list = this.layout[i]
            this.handle({
              status: 'enlarge',
              item: list,
              index: i
            })
            // 搜索
            if (list.type === "detailed") {
              // 明细
              list.curpage = 1;//- 页数还原
              this.getNewFromDatas(i, list)
            } else if (list.type === "summary") {
              // 汇总
              list.devCurpage = 1;//- 页数还原
              this.getSummaryTable(i, list, 1)
            } else if (list.type === "indicatorsBread") {
              // 指标图
              list.devCurpage = 1;//- 页数还原
              this.getIndicatorsDetailsTable(i, list, 1)
            }
          }
        } else {
          // 如果是站内，并选择了应用-提交
          if (item.link === 2 && item.datatype !== 5 && item.datatype !== 7 && item.appIid === 11) {
            const str = await this.getField(item, type)
            console.log('点击打开应用发起', str, item)
            this.$emit('openAppInitiate', {...str, iId: item.appIid, id: item.id})
          } else {
            const str = await this.getOpenUrl(item, type)
            const org = {
              15: true,
              16: true,
              13: true,
              14: true
            }
            if (item.link !== 5 && org[item.appIid] && item.datatype !== 7) {
              this.$emit('openAppInitiate', {approvalId: item.appid, popUps: item.popUps, name:item.name, search: str, iId: item.appIid, datatype: item.datatype, id: item.id})
            } else {
              console.log(str,'strstrstr');
              const obj = {
                  2: 'dialog',
                  3: 'new',
                  4: 'old',
                  5: 'rightdia'
              }
              this.dialogInfo = {
                  isVisible: true,
                  dialogName: '',
                  dialogWidth: item.popUps.w + 'px',
                  dialogHeight: item.popUps.h + 'px',
                  openType: obj[item.open],
                  customSize: item.popUps.customSize,
                  diaSize: item.popUps.diaSize,
                  dialogUrl: str,
              }
              // this.popUpsObj = {
              //   url: str,
              //   popUps: item.popUps,
              //   meterId: item.datatype && item.datatype === 1 ? item.id : ''
              // }
              // this.popUps = true
            }
          }
        }
      } else if (item.open === 3) {
        const str = await this.getOpenUrl(item, type)
        const url = window.location.origin
        // const url = 'https://' + window.location.host
        window.open((item.link !== 3 ? url : '') + str, '_blank')
      } else if (item.open === 4) {
        const str = await this.getOpenUrl(item, type)
        window.location.href = str
      }
      this.jumpArr = []
    },
    // 获取当前需要打开的 url
    async getOpenUrl (item, type) {
      console.log('当前要跳转的', item)
      let str = item.url
      const search = {}
      switch (item.link) {
        case 1:
          str = `/clientSide/instrument/instrument?dataReportId=${this.$route.query.dataReportId}&showId=${item.id}`
          break
        case 2:
          if (type === 'detailed') {
            if (item.datatype === 7) {
              // 7 是报表应用
              str = `/clientSide/reportView/?reportId=${item.appid}`
            } else if (item.datatype === 8) {
              // 8 是 ai小易
              str = `/chat?aiModelId=${item.appid}`
            } else if (item.datatype === 5) {
              // 5 是 仪表盘的
              str = `/clientSide/instrument/instrument?dataReportId=${item.appid}&showSearch=true`
              if (item.open === 4) str += 'navShow=true'
            } else if (item.datatype === 2) {
              str = await this.getApper(item)
              if (str === false) return false
            } else {
              const obs = {
                approvalId: item.appid,
                iId: item.appIid,
                source: 'user',
                name: item.appName,
                navShow: false
              }
              obs[goAppId[item.appIid]] = item.appIid
              // 提交统计走另外的 url
              if (item.appIid === 8) {
                str = `/clientSide/workbench/CycleFillingSetting/CycleFillingSetting?${qs.stringify(obs)}`
              } else {
                str = `/clientSide/application?${qs.stringify(obs)}`
              }
            }
          } else if (item.datatype && item.datatype === 2) {
            str = await this.getApper(item)
            if (str === false) {
              return false
            }
          } else if (item.datatype && item.datatype === 7) {
            str = `/clientSide/reportView/?reportId=${item.appid}`
          } else if (item.datatype && item.datatype === 8) {
            str = `/chat?aiModelId=${item.appid}`
          } else {
            str = `/clientSide/application?approvalId=${item.appid}&source=user&name=${item.appName}`
            if (item.open === 2) str += '&navShow=false'
          }
          break
        case 5:
          str = `/customInstrument?customDeskId=${item.appid}`
          break
      }

      // 不是链接才去找配置，是链接直接计算值
      if (item.link === 1) {
        // 根据 id 找到对应所有配置
        const i = this.layout.findIndex(its => its.i === item.id)
        if (i !== -1) {
          const datas = this.layout[i]
          console.log('查找对应配置', datas)
          // 当前规则只有表内组建才支持
          if (datas.rules && datas.link === 1) {
            //- 外置筛选组件的筛选规则
            search.rules = datas.rules;
          }
          // 本表数据参数
          if (datas.relevanceRules) {
            //- 表单关联表单的筛选规则
            search.relevanceRules = datas.relevanceRules;
          }
        }

        if (search.rules || search.relevanceRules) {
          str += `&search=${JSON.stringify(search)}`
        }
      } else if (item.link === 2) {
        // 应用的话单独配置
        console.log('应用的单独配置1', item, item.linked)
        const obs = {}
        const paramsLists = []
        for (const i of item.linked) {
          let val = i.datatype === 'custom' ? getCustomVal({name: i.name}, this.$store.state.dashboardCustomData || []) : item.value[i.revisabilityName || i.name]
          if (i.type === 'relation-user' && typeof item.user[i.revisabilityName || i.name] === "object") {
            // 如果是发起相关，直接返回数据
            if (item.appIid === 12 || item.appIid === 11) {
              val = item.user[i.revisabilityName || i.name]
            } else {
              if (i.format) {
                if (i.format === 'userId' || i.format === 'realname') {
                  const s = item.user[i.revisabilityName || i.name]
                  if (Array.isArray(s)) {
                    val = s.map(its => its[i.format])
                  } else {
                    val = item.user[i.revisabilityName || i.name][i.format]
                  }
                } else {
                  const userArr = item.user[i.revisabilityName || i.name]
                  if (Array.isArray(userArr)) {
                    const userArrFromat = []
                    for (const e of userArr) {
                      console.log('联系人查询', e)
                      const user = await this.getUserInfo(e.userId)
                      userArrFromat.push(user[i.format || 'realname'])
                    }
                    val = userArrFromat
                    // val = userArrFromat.join(',')
                  } else {
                    const user = await this.getUserInfo(item.user[i.revisabilityName || i.name].userId)
                    val = user[i.format]
                  }
                }
              } else {
                val = item.user[i.revisabilityName || i.name]
              }
            }
          } else if (i.type === 'relation-user' && typeof item.user[i.revisabilityName || i.name] === 'string') {
            val = item.user[i.revisabilityName || i.name]
          } else if (i.type === 'date') {
            val = await this.getTime(val, i.format)
          } else if (i.fatherType && i.fatherType.includes('ready-widget')) {
            val = item.value[filterSymbol(i.revisabilityName)]
            if (val && i.type === 'dates') val = val.split(',')
          } else if (i.type === 'checkbox' && val && typeof val === 'string') {
            val = val.split(',')
          }
          const typeI = i.FormList.findIndex(its => {
            let isCustom = false
            if (i.conditionValue && i.conditionValue.search('custom') !== -1) {
              isCustom = true
            }
            const name = i.conditionValue && i.conditionValue.search('custom') !== -1 ? i.conditionValue.split('_')[0] : i.conditionValue
            return isCustom ? its.name === name && its.datatype === 'custom' : its.name === name
          })
          const typeObj = i.FormList[typeI]
          if (typeObj.datatype === 'custom') {
            paramsLists.push({name: typeObj.name, value: val })
          } else {
            const type = typeObj.type === 'Sizer' ? typeObj.i : typeObj.title + '_' + typeObj.type
            obs[type] = val || ''
          }
        }
        for (const i of item.customize) {
          let val = (i.value || i.value === 0) ? i.value : item.value[i.revisabilityName || i.name]
          if (i.type === 'relation-user' && typeof item.user[i.name] === "object") {
            if (i.format) {
              if (i.format === 'userId' || i.format === 'realname') {
                val = item.user[i.name][i.format]
              } else {
                const user = await this.getUserInfo(item.user[i.name].userId)
                val = user[i.format]
              }
            } else {
              val = item.user[i.name]
            }
          } else if (i.type === 'relation-user' && typeof item.user[i.name] === "string") {
            val = item.user[i.name]
          } else if (i.type === 'date') {
            val = await this.getTime(val, i.format)
          } else if (i.fatherType && i.fatherType.includes('ready-widget')) {
            val = item.value[filterSymbol(i.revisabilityName)]
            if (val && i.type === 'dates') val = val.split(',')
          } else if (i.type === 'checkbox' && val && typeof val === 'string') {
            val = val.split(',')
          }
          if (item.datatype === 5) {
            // 仪表盘另外算
            const types = i.FormList[i.index].i
            if (obs[types]) {
              const vals = Array.isArray(obs[types]) ? obs[types].push(val) : [obs[types], val]
              obs[types] = vals
            } else {
              obs[types] = val
            }
          } else {
            if (item.link !== 3) {
              const typeI = i.FormList.findIndex(its => {
                return its.name === i.conditionValue
              })

              const typeObj = i.FormList[typeI]

              const type = typeObj.type === 'Sizer' ? typeObj.i : typeObj.title + '_' + typeObj.type
              obs[type] = val || ''
            } else {
              obs[i.title + '_' + i.type] = val
            }
          }
        }
        if (JSON.stringify(obs) !== '{}') {
          str += `&search=${JSON.stringify(obs)}`
        }
        if (paramsLists.length > 0) {
          str += `&paramsList=${JSON.stringify(paramsLists)}`
        }
        console.log('应用的单独配置返回', str, obs, item, item.datatype === 2)
      } else if (item.link !== 5) {
        const obs = {}
        for (const i of item.customize) {
          let val = item.value[i.revisabilityName || i.name]
          if (i.type === 'relation-user' && typeof item.user[i.name] === "object") {
            if (i.format === 'userId' || i.format === 'realname') {
              val = Array.isArray(item.user[i.name]) ? item.user[i.name].map(its => its[i.format]).join(',') : item.user[i.name][i.format]
            } else {
              const user = await this.getUserInfo(item.user[i.name].userId)
              val = user[i.format]
            }
          } else if (i.type === 'date') {
            val = await this.getTime(val, i.format)
          }
          if (i.parameter) {
            obs[i.parameter] = val
          } else {
            if (item.link !== 3) {
              const typeI = i.FormList.findIndex(its => {
                return its.name === i.conditionValue
              })

              const typeObj = i.FormList[typeI]

              const type = typeObj.type === 'Sizer' ? typeObj.i : typeObj.title + '_' + typeObj.type
              obs[type] = val || ''
            } else {
              obs[i.title + '_' + i.type] = val
            }
          }
        }
        let obsStr = ''
        for (let i in obs) {
          obsStr += ('&' + i + '=' + obs[i])
        }
        // const obsStr = qs.stringify(obs)
        let strName = '?'
        if (item.link === 3 && item.url && item.url.includes('?')) {
          strName = ''
        } else {
          obsStr = obsStr.substring(1, obsStr.length)
        }
        // if (item.link === 3 && item.url && item.url.includes('?')) strName = '&'
        if (obsStr) str += (strName + obsStr)
      }
      // 从空间进入，需要传空间id
      if(this.isSpace){
        let spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
        str += ((str.includes('?') ? '&' : '?') + ('spaceid=' + spaceId))
      }
      else if(this.isUpace){
        let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        str += ((str.includes('?') ? '&' : '?') + ('upaceid=' + upaceId))
      }
      return str
    },
    async getApper1 (item) {
      const obj = {
        id: item.appid,
        datatype: item.datatype,
        iId: item.appIid
      }
      // 从空间进入，需要传空间id
      if (this.spaceid) {
        obj.spaceid = this.spaceid
      }
      else if (this.upaceid) {
        obj.upaceid = this.upaceid
      }
      if (this.customDeskInfo && this.customDeskInfo.token) {
        obj.accesstoken = this.customDeskInfo.token
      }
      const res = await getbuttonpermission(obj).catch(err => { console.log(err) })
      return res.code === 0 && res.data
    },
    // 获取接入应用权限
    async getApper (item) {
      console.log('下来配置接入应用', item)
      const obj = {
        appid: item.appid,
        datatype: item.datatype
      }
      // 从空间进入，需要传空间id
      if (this.spaceid) {
        obj.spaceid = this.spaceid
      }
      else if (this.upaceid) {
        obj.upaceid = this.upaceid
      }
      if (this.customDeskInfo && this.customDeskInfo.token) {
        obj.accesstoken = this.customDeskInfo.token
      }
      const res = await getappperAuthority(obj).catch(err => { console.log(err) })
      if (item.datatype !== 2) {
        return res
      }
      if (res.code === 0 && res.data.per) {
        return res.data.pcUrl
      } else {
        this.$message.warning(res.msg || '暂无权限!')
      }
      return false
    },
    // 根据配置查询 本表和自定义 数据
    async getField (item, type) {
      console.log('当前要跳转的', item)
      let goObj = {
        url: item.url
      }
      switch (item.link) {
        case 1:
          goObj = {
            ...goObj,
            url: '/clientSide/instrument/instrument',
            dataReportId: this.$route.query.dataReportId,
            showId: item.id
          }
          break
        case 2:
          if (type === 'detailed') {
            // 5 是 仪表盘的
            if (item.datatype === 5) {
              goObj = {
                ...goObj,
                url: '/clientSide/instrument/instrument',
                dataReportId: item.appid,
                showSearch: true
              }
              if (item.open === 4) goObj.navShow = 'true'
            } else {
              goObj = {
                ...goObj,
                url: '/clientSide/application',
                approvalId: item.appid,
                iId: item.appIid,
                source: 'user',
                name: item.appName,
                navShow: false
              }
              goObj[goAppId[item.appIid]] = item.appIid
            }
          } else {
            goObj = {
              ...goObj,
              url: '/clientSide/application',
              approvalId: item.appid,
              source: 'user',
              name: item.appName
            }
            if (item.open === 2) goObj.navShow = false
          }
          break
      }
      // 不是链接才去找配置，是链接直接计算值
      if (item.link === 1) {
        // 根据 id 找到对应所有配置
        const i = this.layout.findIndex(its => its.i === item.id)
        if (i !== -1) {
          const datas = this.layout[i]
          console.log('查找对应配置', datas)
          const search = {}
          // 当前规则只有表内组建才支持
          if (datas.rules && datas.link === 1) {
            //- 外置筛选组件的筛选规则
            search.rules = datas.rules;
          }
          // 本表数据参数
          if (datas.relevanceRules) {
            //- 表单关联表单的筛选规则
            search.relevanceRules = datas.relevanceRules;
          }

          if (search.rules || search.relevanceRules) {
            goObj.search = search
          }

        }
      } else if (item.link === 2) {
        // 应用的话单独配置
        console.log('应用的单独配置2', item)
        const obs = {}
        for (const i of item.linked) {
          let val = i.datatype === 'custom' ? getCustomVal({name: i.name}, this.$store.state.dashboardCustomData || []) : item.value[filterSymbol(i.revisabilityName || i.name)]
          if (i.type === 'relation-user' && item.user && typeof item.user[i.revisabilityName || i.name] === "object") {
            // 去发起直接回去整个结构，不特殊处理
            if (item.appIid === 11 && item.datatype === 1) {
              if (item.user) val = item.user[i.revisabilityName || i.name]
            } else {
              const typeI = i.FormList.findIndex(its => {
                return its.name === i.conditionValue
              })
              const typeObj = i.FormList[typeI]

              // 这里是没有的自定义那种指定输出内容的，所以全部直接匹配(选择对象是申请人表示是搜索的，其他的直接返回整个人员数据)
              if (Array.isArray(item.user[i.revisabilityName || i.name])) {
                val = typeObj.title === '申请人' && typeObj.type === 'relation-user' ? (item.user[i.revisabilityName || i.name]).map(its => its.realname || its.name).join('') : item.user[i.revisabilityName || i.name]
              } else {
                val = typeObj.title === '申请人' && typeObj.type === 'relation-user' ? item.user[i.revisabilityName || i.name].realname : item.user[i.revisabilityName || i.name]
              }
/*
              if (!i.format) i.format = 'realname'
              if (i.format === 'userId' || i.format === 'realname') {
                val = item.user[i.name][i.format]
              } else {
                const user = await this.getUserInfo(item.user[i.name].userId)
                val = user[i.format]
              }
*/
            }
          } else if (i.type === 'date') {
            val = await this.getTime(val, i.format)
          } else if (i.type === 'checkbox' && val && typeof val === 'string') {
            val = val.split(',')
          }
          const typeI = i.FormList.findIndex(its => {
            return its.name === i.conditionValue
          })
          const typeObj = i.FormList[typeI]

          let type = typeObj.type === 'Sizer' ? typeObj.i : typeObj.title + '_' + typeObj.type

          // 如果后面有问题，可能是 typeObj.fatherType 错了，当前内容是为了兼容明细的
          if (typeObj.fatherType && typeObj.fatherType.includes('details')) {
            type = typeObj.fatherType
          }
          // 如果原来值存在的话，就判断格式转成数组，是数组的话则直接添加
          if (obs[type]) {
            if (Array.isArray(obs[type])) {
              obs[type].push(val)
            } else {
              obs[type] = [obs[type], val]
            }
          } else {
            obs[type] = val || ''
          }
        }
        for (const i of item.customize) {
          console.log('自定义遍历', i)
          let val = (i.value || i.value === 0) ? i.value : item.value[i.revisabilityName || i.name]
          if (i.type === 'relation-user' && typeof item.user[i.name] === "object") {
            if (i.format === 'userId' || i.format === 'realname') {
              val = item.user[i.name][i.format]
            } else {
              console.log('查询1', item.user, i.name)
              if (Array.isArray(item.user[i.name])) {
                val = []
                for (const s of item.user[i.name]) {
                  const user = await this.getUserInfo(s.userId)
                  val.push(user[i.format])
                }
              } else {
                const user = await this.getUserInfo(item.user[i.name].userId)
                val = user[i.format]
              }
            }
          } else if (i.type === 'date') {
            val = await this.getTime(val, i.format)
          } else if (i.type === 'checkbox' && val && typeof val === 'string') {
            val = val.split(',')
          }
          if (item.datatype === 5) {
            // 仪表盘另外算
            const types = i.FormList[i.index].i
            if (obs[types]) {
              const vals = Array.isArray(obs[types]) ? obs[types].push(val) : [obs[types], val]
              obs[types] = vals
            } else {
              obs[types] = val
            }
          } else {
            const typeI = i.FormList.findIndex(its => {
              return its.name === i.conditionValue
            })
            const typeObj = i.FormList[typeI]
            const type = typeObj.type === 'Sizer' ? typeObj.i : typeObj.title + '_' + typeObj.type
            obs[type] = val || ''

            // obs[i.title + '_' + i.type] = val
          }
        }
        if (JSON.stringify(obs) !== '{}') {
          goObj.search = obs
        }
      } else {
        const obs = {}
        for (const i of item.customize) {
          let val = item.value[i.revisabilityName || i.name]
          if (i.type === 'relation-user' && typeof item.user[i.name] === "object") {
            if (i.format === 'userId' || i.format === 'realname') {
              val = item.user[i.name][i.format]
            } else {
              console.log('查询2', item.user, i.name)

              const user = await this.getUserInfo(item.user[i.name].userId)
              val = user[i.format]
            }
          } else if (i.type === 'date') {
            val = await this.getTime(val, i.format)
          }
          if (i.parameter) {
            obs[i.parameter] = val
          } else {
            obs[i.title + '_' + i.type] = val
          }
        }
        if (JSON.stringify(obs) !== '{}') {
          goObj = {
            ...goObj,
            ...obs
          }
        }
      }
      return goObj
    },
    async getUserInfo (id) {
      const res = await apiGetmiddleuserbyid({ userId: id }).catch(err => { console.log(err) })
      if (res.code === 0) return res.data
    },
    async getTime (str, format) {
      if (!str || str === 0) return ''
      if (!format) return str
      const date = new Date(str)
      const obs = {
        YYYY: date.getFullYear(),
        MM: date.getMonth() + 1,
        DD: date.getDate()
      }
      return format.split('/').map(item => obs[item]).join('/')
    },
    //- 标图/饼图去除数据里的“.”
    datasReplace (name) {

      if (name.indexOf(".") != -1) {
        //- 说明存在“.”，需要去除
        name = name.replace(".", "");
        return this.datasReplace(name);
      } else {
        return name;

      }


    },
    //- 指标图/饼图客户端数据格式改造(2)
    mergeFun (date) {
      let arr = [];
      if (date && date.length > 0) {
        for (let i = 0; i < date.length; i++) {
          let str = {};
          for (let e in date[i]) {
            if (typeof date[i][e] === 'object') {
              let retStr = this.retsule(date[i][e], e);
              str = Object.assign(str, retStr);
            } else {
              str[e] = date[i][e];
            }
          }
          arr.push(str);
        }

      }

      return arr;
    },


    //- 筛选组件select选中时页面不能滚动
    changeSizerSta (e, callDatas) {
      //- 设置无法滚动
      let value = '';
      if (e && e === true) {
        //- 展示
        value = true;

      } else {
        //- 隐藏
        value = false;
      }
      if (this.$parent.reportClickSta === false || this.$parent.reportClickSta === true) {
        this.$parent.reportClickSta = value;
      }
      //- 缩小的文本组件点击才请求数据
      if (['status', 'text', 'textarea', 'radio', 'checkbox', 'richTextWid', 'new-rel-radio', 'relation-check', 'label'].indexOf(callDatas.FilterField.type) !== -1
        && callDatas.activeName === 'select'
        && callDatas.isAccomplish === false) {

        if (callDatas.w >= 4 && callDatas.h >= 22) {
          //- 无需处理
        } else {
          //- 点击请求筛选数据
          let i = this.layout.findIndex(item => { return item.i === callDatas.i });
          this.layout[i].isAccomplish = true;
          this.layout[i].skeletonLoading = true;
          setTimeout(() => {

            this.getTreeDatas(i);
          }, 1000)
        }




      }

    },

    //- 汇总表格列合并计算
    tableMergeFun (fun, item) {
      let info = fun;
      return this.tableMerge(info, item);
    },
    //- 汇总表格截取数据
    tableFun (arr, curpage, articel, isPartition) {
      const stat = curpage * articel;
      const end = stat - articel;
      let ee = stat >= arr.length ? arr : arr.slice(end, stat)
      if (isPartition) ee = ee.map((it, index) => {
        it.rowIndexNew = index
        return it
      })
      return ee
    },
    //- 表格高度实时判断
    classHeight (height, type) {
      height = parseFloat(height);
      let now_height = 0;
      let differ = 0;
      if (type === 'text') {
        if (this.isFrontEnd === true) {
          //- 后台
          if (height <= 34) {
            differ = 5;
          } else if (height > 34 && height <= 49) {
            differ = 3;
          } else if (height > 49 && height <= 64) {
            differ = 1;
          } else if (height > 64 && height <= 74) {
            differ = 0;
          } else if (height > 74) {
            differ = -4;
          }

        } else {
          //- 前台
          if (height <= 34) {
            height = height - 2;
          } else if (height > 34 && height <= 49) {
            differ = 0;
          } else if (height > 49 && height <= 64) {
            differ = -2;
          } else if (height > 64 && height <= 74) {
            differ = -3;
          } else if (height > 74) {
            differ = -6;
          }
        }

      } else if (type === 'Sizer') {
        if (height <= 34) {
          differ = 5;
        } else if (height > 34 && height <= 49) {
          differ = 3;
        } else if (height > 49 && height <= 64) {
          differ = 1;
        } else if (height > 64 && height <= 74) {
          differ = 0;
        } else if (height > 74) {
          differ = -4;
        }
      }

      now_height = ((height - differ) * 10);

      return now_height;
    },
    //- 表格背景色斑马纹
    getRowClass ({ rowIndex }) {
      if (rowIndex % 2 == 0) {
        //- 偶数
        return 'normal';
      } else {
        //- 奇数
        return 'light';
      }
    },
    //- 表格名称格式修改
    nameChange (val) {
      let new_val = val.split(".");
      new_val = new_val.join("");
      return new_val
    },
    getSles (arr, key) {
      let list = []
      for (const i of arr) {
        if (key.title === i.title && key.type === i.type) {
          if (i.sels) {
            let sels = i.sels
            if (typeof sels === 'string') sels = JSON.parse(sels)
            list = sels.map(its => its.value || its)
          }
          break
        } else if (i.list && i.list.length > 0) {
          return this.getSles(i.list, key)
        }
      }
      return list
    },
    //- 请求接口文本筛选器当前字段数据
    async getTreeDatas (index) {
      const that = this;
      let Filterdatas = that.layout[index].FilterField.datas;
      const checkValueIndex = Filterdatas[0].checkValue;
      that.layout[index].skeletonLoading = true;

      if (Filterdatas[0] && Filterdatas[0].types) {
        const obj = {approvalId: Filterdatas[0].appId}
        if (this.$route.query.upaceid || localStorage.getItem('upaceid')) {
          obj.upaceid = this.$route.query.upaceid || localStorage.getItem('upaceid')
        }
        const res = await openapiGetapproval(obj).catch(err => { console.log(err) })
        let list = []
        if (res.code === 0) {
            try {
              const property = JSON.parse(res.data.property)
              const items = Filterdatas[0].allDatas[Filterdatas[0].checkValue]
              list = this.getSles(property, items)
            } catch(e) {
              console.log('获取错误', e)
            }
        }
        that.layout[index].textDataSelShow = list;
        that.layout[index].skeletonLoading = false
        return
      }

      let submitData = {
        curpage: 1,
        pagesize: 0,
        title: Filterdatas[0].isSource === 1 ? Filterdatas[0].allDatas[checkValueIndex].fatherType : Filterdatas[0].allDatas[checkValueIndex].name
      }
      if (Filterdatas[0].isSource === 1) {
        //-报表
        submitData.approvalId = Filterdatas[0].appId;
        submitData.reportId = 0;
      } else {
        //- 数据工坊
        submitData.approvalId = 0;
        submitData.reportId = Filterdatas[0].appId;
      }
      if (this.$route.query.space || this.$route.query.spaceid) {
        let spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
        submitData.spaceid = spaceId
      }
      else if (this.$route.query.upace || this.$route.query.upaceid) {
        let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        submitData.upaceid = upaceId
      }
      axiosBase(submitData, "/api/getapprovalfieldoptions").then(res => {
        let datas = res.data;
        if (res.code === 0) {

          if (datas.length == 0) {

            that.$message({
              showClose: true,
              type: 'warning',
              message: '暂无数据'
            });

            that.layout[index].checkAll = false;
            that.layout[index].textDataSelShow = [];

          } else {

            for (let i = 0; i < datas.length; i++) {
              if (datas[i]) {
                if (typeof datas[i] === 'object') {
                  for (let a in datas[i]) {
                    if (typeof (datas[i][a]) === "string") {
                      console.log()
                    } else {
                      datas[i][a] = reportpreviewResult(datas[i][a], a);
                    }

                  }
                }
              }
            }

            if (that.layout[index].FilterField.type === "status") {
              //- 状态类型处理
              let status_array = [];
              datas.forEach(item => {
                const ars = that.layout[index].selectArray.length === 1 && (that.layout[index].selectArray[0] === '归档状态' || that.layout[index].selectArray[0] === '归档状态_status') ? ['未归档', '已归档'] : ['进行中', '已通过', '未通过', '已撤回']
                status_array.push(ars[item])
              })
              that.layout[index].textDataSelShow = status_array;
            } else if (that.layout[index].FilterField.type === "cochain") {
              // const ars = ['未存证', '已存证']
              // status_array.push(ars[item])
            } else {
              //- 其他类型处理
              let status_array = [];
              datas.forEach(item => {
                status_array = status_array.concat(item);
              })
              that.layout[index].textDataSelShow = status_array;



            }


          }

        } else {
          that.layout[index].textDataSelShow = [];
          that.layout[index].checkAll = false;
          that.$message.error('文本接口异常');


        }
        that.layout[index].skeletonLoading = false;


      })

    },
    //- 筛选组件重新加载数据---文本筛选器全选功能
    handleCheckAllChange (index) {
      const that = this;
      let layout = that.layout;//- 当前数据
      layout[index].isIndeterminate = false;
      if (layout[index].checkAll === true) {
        const key = layout[index].activeName === 'select' ? 'textDataSelShow' : 'FilterCustomize'
        // 需要查询一次筛选数据
        if (layout[index].searchName || layout[index].searchName === 0) {
          const list = (layout[index][key] || []).filter(its => {
            if (typeof its !== 'string') its = its.toString()
            return its.includes(layout[index].searchName)
          })
          layout[index].FilterValue = list
        } else {
          layout[index].FilterValue = layout[index][key]
        }
      } else {
        layout[index].FilterValue = []
      }
      that.screenIndex = index;
      that.$nextTick(() => {
        that.whetherTurn = true;
        that.getFromnewFun();//- 获取新规则并重新加载表数据
      })

    },
    //- 时间，数值筛选组件变换类型后的展示高度变换
    sizeHightChange (index) {
      const that = this;
      let item = that.layout[index];
      if (item.FilterField.conditionValue === 'between' && item.h < 5) {
        this.layout[index].original_h = JSON.parse(JSON.stringify(item.h))
        this.layout[index].h = 5
      } else if (item.FilterField.conditionValue !== 'between' && item.h >= 5 && item.original_h && item.original_h != 0) {
        this.layout[index].h = JSON.parse(JSON.stringify(item.original_h))

        delete this.layout[index].original_h
      }
    },
    //- 筛选组件重新加载数据---时间重新选择类型
    timeTypeChange (item, index) {
      const that = this;
      //- 大小调整
      that.sizeHightChange(index);
      //- 数据处理
      let layout = that.layout;//- 当前数据
      layout[index].datePickerValue = '';

      if (item.FilterField.conditionValue !== 'between') {
        that.screenIndex = index;
        that.whetherTurn = true;
        that.getFromnewFun();//- 获取新规则并重新加载表数据
      }


    },
    //- 筛选组件重新加载数据---数值重新选择类型
    numberTypeChange (item, index) {
      const that = this;
      //- 大小调整
      that.sizeHightChange(index);
      //- 数据处理
      let layout = that.layout;//- 当前数据
      layout[index].FilterValue = [];

    },
    //- 筛选组件重新加载数据---确认选择成员
    fromMultipleChoice (e) {
      const that = this;
      // let layout = that.layout;//- 当前数据
      let date = [];
      let key = 'checkedUserArr'
      if (that.layout[that.screenIndex].FilterField.type === 'organization') {
        key = 'checkedFlowArr'
      } else if (that.layout[that.screenIndex].FilterField.type === 'roule') {
        key = 'checkedRoleArr'
      }
      if (e[key]) date = (e[key]).map(val => { return val.realname || val.name });
      that.layout[that.screenIndex].FilterValue = date;
      that.layout[that.screenIndex][key] = e[key];
      that.whetherTurn = true;
      that.getFromnewFun();//- 获取新规则并重新加载表数据

    },
    //- 人员删除重新加载数据
    updatePeople (item, index) {
      this.screenIndex = index;
      this.whetherTurn = true;
      this.layout[index].checkedUserArr.splice(0, 1);
      this.getFromnewFun();//- 获取新规则并重新加载表数据
    },
    //- 外置筛选组件触发-----获取新规则并重新加载表数据
    getFromnewFun () {
      const that = this;
      let layout = that.layout;//- 当前数据
      //- 获取新规则
      let screenSign = layout[that.screenIndex];
      let pushdatas = screeningRules(screenSign);
      let List = [];

      screenSign.sourceDatas.forEach((item) => {
        if (item.isChecked === true) {
          //- 循环以表id拿来查询
          List.push({
            i: item.i,
            appId: item.appId,
            reName: item.reName
          })
        }
      })
      const datas = screenSign.FilterField.datas
      //- 改变数据源存储数据,并重新加载关联表数据
      for (let i in List) {
        for (let j in layout) {
          //- 说明是关联的表源,找到这个控件所对应的表格
          if (List[i].appId == layout[j].appId && List[i].i == layout[j].i) {
            // 找到过滤掉字段
            const filterData = datas.find(iten => { return iten.i === List[i].i})
            let isCustom = false
            let filed
            if (filterData) {
              filed = filterData.allDatas[filterData.checkValue]
              if (filed && filed.datatype === 'custom') {
                isCustom = true
              }
            }
            if (!isCustom) {
              let rules = layout[j].rules;
              if (rules.length > 0) {
                //- 说明还有别的筛选规则需要找到在替换
                for (let z in rules) {
                  if (rules[z].filterId == screenSign.i) {
                    layout[j].rules.splice(z, 1, pushdatas);
                  }
                }
              } else {
                if (layout[j].rules == undefined) {
                  layout[j].rules = [];
                }
                // layout[j].rules = rules.concat(pushdatas);

              }
            } else {
              // 过滤的字段是工坊的变量
              const index = layout[j].variableconfig.findIndex(iten => { return iten.name === filed.name })
              if (index !== -1) {
                layout[j].variableconfig[index].value = pushdatas.value
              }
            }
            // 添加重置页数
            if (layout[j].curpage) layout[j].curpage = 1
            if (layout[j].devCurpage) layout[j].devCurpage = 1

            that.$set(layout, j, layout[j]);//- 筛选组件规则更新
          }
        }
      }
      //- 找到关联表数据


      layout.forEach((detail, index) => {
        setTimeout(() => {
          if (detail.type === 'detailed' || detail.type === 'summary' || detail.type === 'indicatorsBread') {
            //- 只有 明细 和 汇总 和 指标/饼图 可以
            for (let itemDetail of List) {
              if (itemDetail.appId === detail.appId && itemDetail.i === detail.i) {
                if (that.whetherTurn === true) {
                  //- 说明是筛选组件触发的需要页数还原
                  if (detail.type === 'detailed') {
                    detail.curpage = 1;
                  } else {
                    // 汇总和指标/饼图参数一样
                    detail.devCurpage = 1;
                  }
                  that.layout[index] = detail //- 还原关联表id的页数参数
                }
                if (detail.type === 'detailed') {
                  // 明细
                  that.getNewFromDatas(JSON.parse(JSON.stringify(index)), detail);
                } else if (detail.type === 'summary') {
                  // 汇总
                  that.getSummaryTable(JSON.parse(JSON.stringify(index)), detail, 1)
                } else if (detail.type === 'indicatorsBread') {
                  // 指标/饼图
                  that.getIndicatorsDetailsTable(JSON.parse(JSON.stringify(index)), detail, 1)
                }
                break;

              }
            }

          } else if (detail.type === 'mutual') {
            // 列表单独更新
            console.log('单独更新的列表', detail, screenSign, this.mutualSearchObj)
            this.getMutualList(screenSign, detail)
            // let list = []
            // const itse = screenSign.FilterField.datas[0].allDatas[screenSign.FilterField.datas[0].checkValue]
            // list = screenSign.FilterValue
            // if (!this.mutualSearchObj[detail.i]) this.mutualSearchObj[detail.i] = {}
            // if (!this.mutualSearchObj[detail.i][itse.title + '_' + itse.type]) this.mutualSearchObj[detail.i][itse.title + '_' + itse.type] = {}
            // this.mutualSearchObj[detail.i][itse.title + '_' + itse.type][screenSign.i] = list
            // console.log('查询数据结构', this.mutualSearchObj)
            // // 做整合结构
            // const query = {}
            // if (this.mutualSearchObj[detail.i]) {
            //   for (const s in this.mutualSearchObj[detail.i]) {
            //     let ars = Object.values(this.mutualSearchObj[detail.i][s]).flat(Infinity)
            //     console.log('便利的是', ars, s)
            //     if (ars.length > 0) {
            //       query[s] = [...new Set(ars)]
            //     }
            //   }
            // }
            //   setTimeout(() => {
            //     const dom = this.$refs[detail.i + 'mutual']
            //   if (dom[0] || dom) (dom[0] || dom).handlerQuery(query)
            //   }, 50)
          }

        }, 100)

      })

      if (that.whetherTurn === true) {
        //- 说明是筛选组件触发的需要页数还原
        that.whetherTurn = false;
      }
    },
    // 触发应用列表更新
    getMutualList (screenSign, detail) {
      let list = []
      const itse = screenSign.FilterField.datas[0].allDatas[screenSign.FilterField.datas[0].checkValue]
      list = screenSign.FilterValue
      if (!this.mutualSearchObj[detail.i]) this.mutualSearchObj[detail.i] = {}
      if (!this.mutualSearchObj[detail.i][itse.title + '_' + itse.type]) this.mutualSearchObj[detail.i][itse.title + '_' + itse.type] = {}
      this.mutualSearchObj[detail.i][itse.title + '_' + itse.type][screenSign.i] = list
      console.log('查询数据结构', this.mutualSearchObj)
      // 做整合结构
      const query = {}
      if (this.mutualSearchObj[detail.i]) {
        for (const s in this.mutualSearchObj[detail.i]) {
          let ars = Object.values(this.mutualSearchObj[detail.i][s]).flat(Infinity)
          console.log('便利的是', ars, s)
          if (ars.length > 0) {
            query[s] = [...new Set(ars)]
          }
        }
      }
      setTimeout(() => {
        const dom = this.$refs[detail.i + 'mutual']
      if (dom[0] || dom) (dom[0] || dom).handlerQuery(query)
      }, 50)
    },
    //- 筛选组件触发数据筛选
    selectFromsDatas (item, type, index) {
      const that = this;
      that.screenIndex = index;
      that.whetherTurn = true;
      if (type === 'user') {
        console.log('触发联系人选择', item, type, index)
        //- 联系人控件
        let date = {
          onlyUser: true,
          radio_: false,
          apiurl: this.isFrontEnd ? true : false,
        };
        let key = 'checkedUserArr'
        if (item.FilterField.type === 'organization') {
          date.isrole = true
          date.isuser = true
          date.onlyUser = false
          key = 'checkedFlowArr'
        } else if (item.FilterField.type === 'roule') {
          date.isorgs = true
          date.isuser = true
          date.onlyUser = false
          key = 'checkedRoleArr'
        }
        date[key] = item[key] && item[key].length > 0 ? item[key] : []//- 已经选择用户数据
        if (item.organize && item.organize.length > 0) {
          date.lookCustomArr = item.organize
          date.isapiurl = "/openapi"
          date.isrole = true
        }
        that.$refs.multipleChoiceRef.multipleChoiceMethod(date);
      } else if (type === 'orgUser') {
        this.getFromnewFun()
      } else if (type === 'number' || type === 'two_number') {
        //- 单个,多个数值筛选器
        that.getFromnewFun();//- 获取新规则并重新加载表数据
      } else if (type === 'time') {
        //- 时间筛选器
        that.getFromnewFun();//- 获取新规则并重新加载表数据
      } else if (type === 'textOne') {
        //- 文本筛选器多表同源
        that.getFromnewFun();//- 获取新规则并重新加载表数据
      } else if (type === 'textTwo') {
        //- 文本筛选器多表同源
        that.getFromnewFun();//- 获取新规则并重新加载表数据
      }
    },
    //- 分页按钮选择后重新刷新表数据(明细)
    pageChange (e) {
      console.log('下来的分页', e)
      let index = e.index;
      let curpage = e.curpage;//- 第几页
      let article = e.article;//- 页数
      let itemDatas = this.layout[index];
      if (curpage) {
        itemDatas.curpage = curpage;
      }
      if (article) {
        itemDatas.article = article;
        itemDatas.curpage = 1;
      }
      this.getNewFromDatas(JSON.parse(JSON.stringify(index)), itemDatas);

    },
    //- 分页按钮选择后重新刷新表数据(汇总)
    sumPageChange (e) {
      let index = e.index;
      if (e.i) {
        const ei = this.layout.findIndex(it => it.i === e.i)
        if (ei !== -1) {
          index = ei
        }
      }

      let curpage = e.curpage;//- 第几页
      let article = e.article;//- 页数
      let itemDatas = this.layout[index];
      if (curpage) {
        itemDatas.devCurpage = curpage;
      }
      if (article) {
        itemDatas.devArticle = article;
        itemDatas.devCurpage = 1;
      }
      // 如果是客户端的话去请求接口
      if (!this.isFrontEnd) {
        this.getSummaryTable(index, JSON.parse(JSON.stringify(itemDatas)), 0);
      }
    },
    //- 分页按钮选择后重新刷新表数据(指标)
    indicatorsChange (e) {
      let index = e.index;
      let curpage = e.curpage;//- 第几页
      let article = e.article;//- 页数
      let itemDatas = this.layout[index];
      if (curpage) {
        itemDatas.devCurpage = curpage;
      }
      if (article) {
        itemDatas.devArticle = article;
        itemDatas.devCurpage = 1;
      }
      // 如果是客户端的话去请求接口
      if (!this.isFrontEnd) {
        this.getIndicatorsDetailsTable(index, JSON.parse(JSON.stringify(itemDatas)), 0);
      }
    },
    //- 汇总过滤方法
    merge (date, orj) {
      let arr = [];
      for (let i = 0; i < date.length; i++) {
        let str = {};
        for (let e in date[i]) {
          if (orj[e] && (orj[e] === 'text' || orj[e] === 'textarea') && typeof date[i][e] !== 'string') {
            date[i][e] = Array.isArray(date[i][e]) ? date[i][e].join() : JSON.stringify(date[i][e])
          }
          if (typeof date[i][e] === 'object') {
            let retStr = this.retsule(date[i][e], e);
            str = Object.assign(str, retStr);
          } else {
            str[e] = date[i][e];
          }
        }
        arr.push(str);
      }
      return arr;
    },
    //- 指标图/饼图/汇总/明细客户端数据格式改造
    retsule (data, name) {
      let strObj = {};
      // 区分 [] 和 {}
      if (Array.isArray(data)) {
        if (data[0] && data[0].realname !== undefined) {
          let ars = data.map(val => { return val.realname });
          strObj[name] = ars.join(',');
        } else if (data[0] && data[0].response) {
          strObj[name] = data;
        } else if (data[0] && data[0].date && data[0].time) {
          // 他是属于预约时间段的，不做任何转化
          strObj[name] = data
        } else if (data[0] && data[0].name) {
          // 组织或者角色
          strObj[name] = data
        } else {
          strObj[name] = data.join(',');
        }
      } else {
        if (data.realname) {
          strObj[name] = data.realname;
        } else {
          for (let i in data) {
            if (typeof data[i] === 'object') {
              let retStrs = this.retsule(data[i], (name + '.' + i));
              strObj = Object.assign(strObj, retStrs);
            } else {
              strObj[name + '.' + i] = data[i];
            }
          }
        }
      }
      return strObj;
    },
    //- 汇总
    tableMerge (listTable, datas) {
      let ars = [];
      let tableData = listTable;
      let retName = '';
      let len = datas.row && datas.row[0] && datas.row[0].partition ? 1 : 0
      for (let a = len; a < (datas.row || []).length; a++) {
        let arsArr = [];
        let post = 0;
        let rowNames = filterStr(datas.row[a].name);
        // let rowNames = filterSymbol(datas.row[a].name);
        if (a > 0) retName = filterStr(datas.row[a - 1].name);
        // if (a > 0) retName = filterSymbol(datas.row[a - 1].name);
        // console.log('计算合并', tableData, datas.row[a], rowNames)
        for (let i = 0; i < tableData.length; i++) {
          if (i === 0) {
            arsArr.push(1);
            post = 0;
          } else {
            // 这里需要区分 row 是不是第一个
            if (a === 0) {
              if (JSON.stringify(tableData[i][rowNames]) === JSON.stringify(tableData[i - 1][rowNames])) {
                arsArr[post] += 1;
                arsArr.push(0);
              } else {
                arsArr.push(1);
                post = i;
              }
            } else {
              let one = tableData[i][retName] + tableData[i][rowNames];
              let two = tableData[i - 1][retName] + tableData[i - 1][rowNames];
              if (one === two) {
                arsArr[post] += 1;
                arsArr.push(0);
              } else {
                arsArr.push(1);
                post = i;
              }
            }
          }
        }
        ars.push(arsArr);
      }
      return ars;
    },
    //- 明细表表格配置格式转换
    formatChange (date) {
      let new_array = [];
      date.forEach(detail => {
        let new_obj = {}
        for (let j in detail) {
          let new_key = j.split(".");
          new_key = new_key.join("");
          new_obj[new_key] = detail[j]
        }
        new_array.push(new_obj)
      })
      return new_array;
    },

    //- 由父级数据源告诉drage层数据源更新
    async changeFatoSon (datas, text) {
      console.log('下来告知更新的数据源', datas, text)
      datas = JSON.parse(JSON.stringify(datas));
      const s = this.layout.findIndex(its => its.i === datas.i)
      if (s !== -1) {
        this.layout[s] = datas
        // 只有汇总表需要这样做
        if (datas.type === 'summary') {
          this.layout[s].skeletonLoading = true
          setTimeout(() => {
            this.layout[s].skeletonLoading = false
          }, 300);
        }
      }
    },
    //- 汇总请求行列结果集
    resultArr (date, arr) {
      let ars = date.map(val => {
        let str = {};
        for (let i = 0; i < arr.length; i++) {
          str[arr[i].name] = val[arr[i].name];
        }
        return str;
      });
      return ars;
    },
    //- 下载表格
    async loadDatas (e) {
      const that = this;
      let mergeRules = [];
      if (e.item.rules && e.item.rules != undefined) {
        //- 外置筛选组件的筛选规则
        mergeRules = mergeRules.concat(e.item.rules);
      }
      if (e.item.relevanceRules && e.item.relevanceRules != undefined) {
        //- 表单关联表单的筛选规则
        mergeRules = mergeRules.concat(e.item.relevanceRules);
      }
      let submitDatas = {
        approvalDashboardId: that.$parent.submitDataAlls.approvalDashboardId,//- 仪表盘id
        index: e.index,//- 仪表盘索引
        value: JSON.stringify(mergeRules),//- 筛选组件提交的筛选值
        curpage: 0,//- 当前页
        pagesize: 0,//- 每页条数
        export: 1,//- 是否导出数据,1为导出，其它不导出
        querys: e.item.querys ? e.item.querys : '',//- 仪表盘验证过滤数据
      }
      // 从空间进入，需要传空间id
      if(this.isSpace){
        let spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
        submitDatas.spaceid = spaceId;
      }
      else if (this.isUpace) {
        let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        submitDatas.upaceid = upaceId
      }
      const datas = e.item
      // 替换一下变量的值
      const customDataList = this.$store.state.dashboardCustomDataObj[this.$parent.submitDataAlls.approvalDashboardId] || this.$store.state.dashboardCustomData || []
      if (customDataList.length > 0) {
        // 存在$就是自定义的变量
        submitDatas.customData = setCustomData(customDataList)
      } 
      if (datas.isSource === 2 && Array.isArray(datas.variableconfig) && datas.variableconfig.length > 0) {
        const customData = submitDatas.customData ? submitDatas.customData : {}
        const variableconfig = await setConfigCustomData(cloneDeep(datas.variableconfig))
        console.log(variableconfig, '工坊变量')
        variableconfig.forEach(item => {
          customData[item.name] = item.value || item.value === 0 ? item.value : ''
        })
        submitDatas.customData = JSON.stringify(customData)
      }
      apiUploadview(submitDatas).then(res => {
        clearInterval(that.$refs.progressRefs.timer);
        if (res.code === 0) {
          // that.$refs.progressRefs.percentage = 100;
          // that.$refs.progressRefs.downLoadUrl = res.data;
          that.$refs.progressRefs.closeTimeFun(res.data);
        } else {
          that.$refs.progressRefs.percentage = -1;
          that.$message({
            showClose: true,
            type: 'info',
            message: '下载失败'
          });
        }

      }).catch(error => { console.log(error) });
    },
    //- 功能区--修改,复制,删除,扩大，下载，刷新
    handle (e) {
      const that = this;
      console.log(e,'<------------e');
      if (e.status == 'amend') {
        // 判断relevance
        if (e.item.type === 'detailed' && !e.item.relevance) {
          e.item.relevance = []
        }
        if (e.item.type === 'summary' && !e.item.isContainer) {
          const dom = this.$refs['grid-item' + e.item.i]
          const width = Array.isArray(dom) ? dom[0].$el.clientWidth : dom.$el.clientWidth
          e.item.width = width
        }
        // 是明细，并且没有模式设置，给个初始化值
        // if (e.item.type === 'detailed' && !e.item.dataSchema) e.item.dataSchema = 'details'
        //- 明细表，汇总表修改
        that.$emit('retGoUp', e.item);
      } else if (e.status == 'copy') {
        //- 明细表，汇总表复制
        if (e.item.skeletonLoading === true) {
          that.$message({
            showClose: true,
            type: 'info',
            message: '还没加载完无法复制'
          });
          return;
        }
        let date = JSON.parse(JSON.stringify(e.item));
        date.i = generate_IsMathRandom(that.layout);
        // 图片、文件组件复制名称
        if(date.type === 'swiper' || date.type === 'text')date.reName = date.name + '_拷贝1'
        else date[date.type === 'Sizer' ? 'datasName' : date.type === 'mutual' ? 'name' : 'reName'] += '_拷贝2';
        console.log('复制表', e, date)
        // 如果是容器，需要把子集同步复制下
        if (date.type === "container") {
          for (let i = 0; i < (date.children || []).length; i++) {
            const iConfig = JSON.parse(JSON.stringify(date.children[i]))
            iConfig.id = generate_IsMathRandom(date.children, 'id')
            for (let a = 0; a < (iConfig.children || []).length; a++) {
              const layInd = this.layout.findIndex(itss => itss.i === iConfig.children[a])
              if (layInd !== -1) {
                const layConfig = JSON.parse(JSON.stringify(this.layout[layInd]))
                layConfig.i = generate_IsMathRandom(this.layout)
                layConfig.reName = layConfig.reName + "_拷贝"
                iConfig.children[a] = layConfig.i
                this.layout.push(layConfig)
              }
            }
            date.children[i] = iConfig
          }
        }
        that.layout.push(date);
      } else if (e.status == 'delete') {
        const obs = JSON.parse(JSON.stringify(this.layout[e.index]))
        if (this.draggableObj[obs.i]) this.draggableObj[obs.i] = false
        // 如果是容器组件里面的，容器里面的索引也要同步删除
        console.log('容器删除', obs)
        //- 明细表，汇总表删除
        this.layout.splice(e.index, 1);
        // 容器删除要把里面的子项全部一起清理掉
        if (obs.type === 'container') {
          for (const i of obs.children) {
            for (const a of (i.children || [])) {
              const ia = this.layout.findIndex(its => its.i === (a.i || a))
              if (ia !== -1) this.layout.splice(ia, 1)
            }
          }
        }
        this.$forceUpdate()
      } else if (e.status == 'Textamend') {
        //- 文本组件功能--富文本获得焦点后禁止拖拽
        that.$message({
          showClose: true,
          type: 'success',
          message: '文本组件已锁定'
        })
        this.draggableObj[e.item.i] = true
      } else if (e.status == 'Textclose') {
        //- 文本组件功能--富文本失去焦点后拖拽还原
        that.$message({
          showClose: true,
          type: 'success',
          message: '文本组件解锁完成'
        })
        this.draggableObj[e.item.i] = false
      } else if (e.status == 'enlarge') {
        //- 明细表，汇总表组件功能-扩大
        console.log('明细表，扩大', e.item, e)
        that.drawerDatasIndex = e.index;
        that.drawerDatas = JSON.parse(JSON.stringify(e.item));
        that.drawer = true;
      } else if (e.status == 'update') {
        //- 明细表，汇总表组件功能-更新数据
        if (e.item.type === 'detailed') {
          //- 明细
          that.getNewFromDatas(JSON.parse(JSON.stringify(e.index)), e.item);

        } else if (e.item.type === 'summary') {
          //- 汇总

          let item = e.item;
          item.devCurpage = 1;
          this.getSummaryTable(e.index, item, 1);


        } else if (e.item.type === 'indicatorsBread') {
          //- 指标图/饼图

          let item = e.item;
          item.devCurpage = 1;
          this.getIndicatorsDetailsTable(e.index, item, 1);


        }
      } else if (e.status == 'upload') {
        /*//- 明细表，汇总表组件功能-下载数据
        if(e.item.skeletonLoading === true){
          that.$message({
            showClose: true,
            type: 'info',
            message: '还没加载完无法下载'
          });
          return;
        }
        that.progressShow = true;
        that.$nextTick(()=>{
          that.$refs.progressRefs.index = e.index;
          that.$refs.progressRefs.datas = e.item;
        })
        that.loadDatas(e);*/
console.log('刷新', e)
        this.$emit('downloadInfo', e)
      } else if (e.status == 'empty') {
        //- 清空关联表单联动条件值
        let index = e.index;
        let layout = that.layout[index];
        //- 取消选中显示效果
        if (layout.type === "indicatorsBread") {
          //- 双行指标图/饼图
          // layout.selectIndex = null;



        } else if (layout.type === "summary") {
          // that.$refs['sumTableRefs_'+layout.i][0].clearSelect();
          layout.selectRow = null;
          layout.selectCloum = null;

        }
        if (that.drawer !== true) {
          this.changeRelevanceFunClose({
            id: layout.i,
            value: ''
          })

        } else {
          this.changeRelevanceFunClose({
            id: layout.i,
            value: ''
          }, true)

        }


      } else if (e.status === 'show') {
        this.viewShowFun(e)
      } else if (e.status === 'edit') {
        // 修改富文本
        // let index = e.index
        // if (e.i !== undefined) {
        //   index = this.layout.findIndex(item => {
        //     return item.i === e.i && item.type !== 'container'
        //   })
        // }
        // this.$refs.richTextEdit.open(this.layout[index], this.$store.state.dashboardCustomData, index)
      }
    },
    // 下载(通过上一级直接调用方法触发)
    download (e) {
      //- 明细表，汇总表组件功能-下载数据
      if (e.item.skeletonLoading === true) {
        this.$message({
          showClose: true,
          type: 'info',
          message: '还没加载完无法下载'
        });
        return;
      }
      this.progressShow = true;
      this.$nextTick(() => {
        this.$refs.progressRefs.index = e.index;
        this.$refs.progressRefs.datas = e.item;
      })
      this.loadDatas(e);
    },
    //- 扩大区域关闭
    handleClose () {
      // this.$confirm('确认关闭？')
      // .then(_ => {
      this.drawer = false;
      // })
      // .catch(_ => {});
    },
    //- 文本组件--由子级数据源告诉drage层数据源更新，并告诉在爷爷层级更新数据
    changeSontoFa (val) {
      this.changeFatoSon(val);
    },
    // 容器进来的添加内容
    addContainer ({index, type}) {
      this.drop(type, index)
    },
    allowDrop (event) {
      event.preventDefault();
    },
    // 数据原因 结构进来生成（界面节点生成）
    async drop (event, key) {
      if (this.isFrontEnd) {
        // 如果是容器里面，但是没有栏目的话，拦截掉不添加
      if ((key || key === 0) && (!this.layout[key] || this.layout[key] && this.layout[key].children.length === 0)) {
        this.$message.warning('请先添加栏目!!')
        return
      }
        const data = key || key === 0 ? event : event.dataTransfer.getData("nodeData");
        if (data) {
          const str = generGrid(data, this.layout);
          if (key || key === 0) {
            // 容器里面的专属
            str.isContainer = true
            str.w = 0
            str.h = 0
            str.x = 0
            str.y = 0
            if (!this.layout[key].children[this.layout[key].selected].children) {
              this.layout[key].children[this.layout[key].selected].children = [str.i]
            } else {
              this.layout[key].children[this.layout[key].selected].children.push(str.i)
            }
            // this.layout[key].children.push(str.i)
          }
          this.layout.push(str);
          // 可视化初始要获取大小来备用计算
          if (str.type === 'indicatorsBread' || str.type === 'detailed' || str.type === 'summary') {
            await this.$nextTick()
            setTimeout(() => {
              const strI = key || key === 0 ? this.layout[key].i : str.i
              const dom = this.$refs['grid-item' + strI]
              if (dom && (dom[0] && dom[0].style || dom.style)) {
                const style = (dom[0] || dom).style
                str.width = style.width
                str.height = style.height
              }
              this.$parent.buildSubmit(str);
            }, 100)
          } else if (str.type === 'container') {
            console.log('打开容器配置框')
            this.containerEditorFun(str, this.layout.length - 1)
          } else if (str.type === 'mutual') {
            this.$emit('mutualEditor', str)
          } else if(str.type === 'swiper'){

            this.$parent.buildSubmit(str);
            this.handle({status: 'amend', item: str})
          }else {
            this.$parent.buildSubmit(str);
          }
        }

      }
    },
    //- 指标图/饼图客户端值改造(1)
    valueRemould (data, row, summary,seriesType, item) {
      const res = data
      const arr = []
      console.log(seriesType,'asdad');
      if(seriesType === 'name'){
        // 循环行
        summary.forEach( (s,index) => {
          // 定义对象容器
          const obj = {}
          // 获取行名
          const name = s.name1
          // 获取汇总名
          const sname = item.isSource !== 11 ? s.name : s.key //系统数据表传key
          const sname1 = s.name
					// 获取计算类型
					let m = sname1.search(/\(/)
					let n = sname1.search(/\)/)
					const summaryType = sname1.slice(m+1,n)
          console.log(name,sname,summaryType);
          // 定义数组存储对应行名数据
          let value = 0
          // 循环数据 item为对象
          for (let i = 0; i < data.length; i++) {
            switch (summaryType){
              case '求和':
              case '计数':
                value += data[i][sname]
                break
              case '求平均':
                value += data[i][sname]
                if(i === data.length - 1){
                  value = value / data.length
                }
                break
              case '求最大值':
                if(i === 0)value = data[0][sname]
                value = value > data[i][sname] ? value : data[i][sname]
                break
              case '求最小值':
                if(i === 0)value = data[0][sname]
                value = value < data[i][sname] ? value : data[i][sname]
                break
            }
          }
          obj.name = name || ''
          obj.value = value
          if(index === 0)obj.seriesType = seriesType
          arr.push(obj)
        });
        console.log(arr);
        return arr
      }
      const statObj = {
        0: '进行中',
        1: '已通过',
        2: '未通过',
        3: '已撤回'
      }
      for (const i of res) {
        const obj = {
          name: ''
        }
        for (const r of row) {
          const rowName = item.isSource !== 11 ? r.name + (r.type === 'date' && r.format !== 'yyyy-MM-dd HH:mm:ss' ? "(因为时间字段特殊)" : '') : r.key
          let name = (r.type === 'status' && statObj[i[rowName]] ? statObj[i[rowName]] : i[rowName] || i[rowName] === 0 ? i[rowName] : i[r.name] || '')
          if (Array.isArray(name)) {
            name = name.map(item => {
              if (item.organizationId) {
                return getOrgShowName(item)
              } else {
                return item.name || item.realname || item
              }
            }).join()
          }
          obj.name += (!obj.name && obj.name !== 0 ? '' : '\u0001') + name
        }
        for (const s of summary) {
          const summaryName = row.length === 0 ? item.isSource !== 11 ? s.revisabilityName : s.key : s.name + (row.length === 0 ? '(单个指标图特殊显示)' : '')
          obj[s.title] = item.isSource !== 11 ? (i[summaryName] || i[summaryName] === 0 ? i[summaryName] : i[s.name]) || '' : (i[s.key] || '')
        }
        arr.push(obj)
      }
      console.log('指标图结果返回', arr, data, row)
      return arr
    },
    layoutUpdatedEvent: function () {
      // console.log("Updated layout: ", newLayout)
      if (!this.isFrontEnd || !this.styleTemp.absorb || this.styleTemp.absorb !== 'open') return
      for (let i = 0; i < this.layout.length; i++) {
        if (this.layout[i].linkTop || this.layout[i].linkBottom) {
          const obs = this.getTb(this.layout[i])
          if (this.layout[i].linkTop) this.layout[i].linkTop = obs.isTop.length > 0
          if (this.layout[i].linkBottom) {
            const obb = obs.isBottom.filter(it => it.linkTop)
            this.layout[i].linkBottom = obb.length > 0
          }
        }
      }
    },
    getTb (data) {
      const obs = {}
      const x1 = data.x
      const x2 = data.x + data.w
      const y1 = data.y
      const y2 = data.y + data.h
      obs.isTop = this.layout.filter(it => {
        const t1 = it.x
        const t2 = it.x + it.w
        const ty = it.y + it.h
        return it.i !== data.i && ty === y1 && t1 <= x1 && x2 <= t2
      })
      obs.isBottom = this.layout.filter(it => {
        return it.i !== data.i && x1 <= it.x && it.x <= x2 && it.y === y2
      })
      return obs
    },
    // - 编辑功能放回
    editCallBack (callbackDatas) {
      const that = this
      if (callbackDatas) {
        // - 修改数据
        const i = that.layout.findIndex(findItem => {
          return findItem.i === callbackDatas.i
        })
        if (callbackDatas.type === 'mutual') {
          that.applyType = {
            ...callbackDatas
          }
        }
        console.log('i', i)
        that.layout[i] = JSON.parse(JSON.stringify(callbackDatas))
      }
    },
    // 背景填充设置
    bgfillSet(bgfllStyle,transparentBackground){
      if(bgfllStyle && !transparentBackground){
        let fillstyle = {}
        if(bgfllStyle.bgstyle === 'picture'){
          // 背景填充图片
          if(bgfllStyle.picture.layout === 'default'){
            // 原大小填充
            fillstyle.background = `url('${this.$imgurl + bgfllStyle.picture.url}') no-repeat`
          }else if(bgfllStyle.picture.layout === 'adaption'){
            // 自适应填充
            fillstyle.background = `url('${this.$imgurl + bgfllStyle.picture.url}') no-repeat`
            fillstyle.backgroundSize = '100% 100%'
          }
        }else if(bgfllStyle.bgstyle === 'color'){
          // 背景填充颜色
          fillstyle.backgroundColor = bgfllStyle.color
        } else if(bgfllStyle.bgstyle === 'temp'){
          // 背景填充颜色
          fillstyle.backgroundRepeat = 'no-repeat'
          fillstyle.backgroundSize = '100% 100%'
          fillstyle.backgroundPositionY = 'center'
          fillstyle.backgroundImage = 'url(https://bigdata.topeti.com/PCRepository/mainPlatform/dashboardBg.png)'
          if (bgfllStyle.bgTemp === 0) {
            fillstyle.backgroundColor = '#333'
          } else {
            fillstyle.backgroundColor = '#FFF'
          }
        }
        return fillstyle
      }else{
        return ''
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.img-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  &:not(:empty) {
    margin-bottom: 5px;
    margin-top: 6px;;
  }
  .img-tt {
    display: flex;
    align-items: center;
    margin-right: 14px;
    // margin-bottom: 5px;
    // margin-top: 6px;;
    &:last-child {
      margin-right: 0;
    }
  }
  .img-tt-i {
    width: 25px;
    height: 25px;
  }
  .img-tt-v {
    font-size: 14px;
    color: #666;
  }
}

.link-top-b {
  margin-top: -9px;
  .grid-drage {
    padding-top: 9px;
    border-top: none;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    box-shadow: 2px 7px 8px 0px rgba(186, 186, 186, 0.5);
    &:hover {
      border-top: none !important;
      box-shadow: 2px 7px 8px 0px rgba(186, 186, 186, 0.5) !important;
    }
  }
  :deep(.vue-resizable-handle) {
    bottom: -10px;
  }
}
.link-bottom-b .grid-drage {
  border-bottom: none;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  box-shadow: 2px -7px 8px 0px rgba(186, 186, 186, 0.5);
  &:hover {
    border-bottom: none;
    box-shadow: 2px -7px 8px 0px rgba(186, 186, 186, 0.5);
  }
}
.grid-container {
  padding-left: 0 !important;
  padding-right: 0 !important;
  width: calc(100% - 2px) !important;
}
.container-title {
  height: 53px;
  box-sizing: border-box;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  padding: 7px 11px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;
}
.container-style-left {
  display: flex;
  .container-header {
    bottom: 10px;
    top: auto;
    right: auto;
    left: 10px;
  }
}
.container-header {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 102;
  padding: 5px 10px;
  background-color: #ffffff;
  border-radius: 4px;
  .container-header-list {
    padding-left: 5px;
    padding-right: 5px;
    cursor: pointer;
  }
}
.no-data {
  text-align: center;
  position: relative;
  top: calc(50% - 45px);
  color: #999;
}
  :deep(.popUps) {
    border-radius: 14px;
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    max-height: calc(100% - 30px);
    max-width: calc(100% - 30px);
    .el-dialog__header {
      padding: 18px;
      background-color: #F5F5F5;
      border-radius: 14px 14px 0 0;
    .el-dialog__title{
      font-size: 14px;
      color: #333;
      font-weight: 400;
    }
    .el-dialog__headerbtn{
      top: 8px;
      font-size: 20px;
    }
  }
    .el-dialog__body {
      padding: 5px;
    }
  }
.bTransparent {
  background: transparent !important;
}
.pTransparent {
  box-shadow: none !important;
  border-color: transparent !important;
}
.filter-grid-text {
  /*width: auto !important;*/
  min-width: 50px;
}
.filter-center {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding-top: 7px;
  padding-bottom: 7px;
  overflow: hidden;
  height: calc(100% - 14px);
  .filter-title-text {
    /*width: 47%;*/
    /*overflow: hidden;*/
    /*text-overflow: ellipsis;*/
    white-space: nowrap;
    color: #333333;
    font-weight: bold;
    padding-right: 10px;
    padding-top: 7px;
    /*white-space: nowrap;*/
    max-width: 80%;
  }
  .filter-title-text-horizontal {
    line-height: 30px;
    padding-top: 0;
    padding-right: 8px;
    font-size: 14px;
  }
  .icon-shaixuan2 {
    padding-right: 5px;
    color: #4e86ff;
  }
  .filter-editor {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0, 0.5);
    border-radius: 4px;
    z-index: 2;
    left: 0;
    top: 0;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    display: none;
    i {
      color: #ffffff;
      margin-left: 10px;
      cursor: pointer;
    }
  }
}
.Sizer:hover .filter-editor {
  display: flex;
}
:deep(input) {
  height: 30px;
  line-height: 30px;
}
:deep(.el-input__icon) {
  // margin-top: 6px;
  &.el-icon-search {
    margin-top: -4px;
  }
}
:deep(.el-input--prefix) {
  .el-input__suffix {
    margin-top: -10px;
  }
}
:deep(.el-date-editor) {
  .el-icon-date,
  .el-icon-date,
  .el-range__close-icon {
    line-height: 0px;
  }
  input {
    height: 28px;
    line-height: 28px;
  }
  .el-range-separator {
    line-height: 23px;
  }
}
.textArea, .textAreaHou {
  width: 100% !important;
  padding: 0 !important;
}
.textAreaHou {
  :deep(.w-e-toolbar) {
    border: none !important;
  }
  :deep(.w-e-text-container) {
    height: 97.9% !important;
    border: none !important;
    background: none;
  }
  :deep(.w-e-text) {
    border: none !important;
  }
}

.summarizing :deep(.sum-table-all-height) {
  height: 100%;
}

.drage-grid {
  width: 100%;
  height: 100%;
}
:deep(.btt) {
  height: 100% !important;
}

.grid-drage {
  width: calc(100% - 22px);
  height: 100%;
  padding-left: 11px;
  padding-right: 11px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 2px 2px 8px 0px rgba(186, 186, 186, 0.5);
  border-radius: 4px;
  border: 1px solid rgba(235, 235, 235, 1);
  // overflow: hidden;
  position: relative;
  .coverText {
    width: 93.9%;
    height: 86.9%;
    position: absolute;
    z-index: 99;
    background: rgba(0, 0, 0, 0);
    top: 51px;
    left: 1%;
  }
  &:hover {
    box-shadow: 2px 2px 16px 0px rgba(186, 186, 186, 1);
    border: 1px solid rgba(235, 235, 235, 1);
  }

  :deep(.el-table__row:hover) {
    background: #f3f6fa;
  }
  
  &.detailing :deep(.tableDetail) {
    height: calc(100% - 5px);
    //overflow-x: hidden;
    // .styleGroup {
    //   width: 95.99%;
    //   padding: 10px 2px;
    // }
    &::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
      border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.2);
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: rgba(0, 0, 0, 0.5);
    }

    &::-webkit-scrollbar-corner {
      background: transparent;
    }
  }
  &:hover :deep(.admin-selectBox) {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
    z-index: 101;
    top: 0;
    left: 0;
    justify-content: center;
    color: #ffffff;
    border-radius: 4px;
    display: flex;
  }
  &:hover :deep() .selectBox {
    display: flex;
  }
}
.detailing  {
  :deep(.selectBoxArea) {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}
.grid-table {
  width: 100%;
  height: 92%;
  overflow: hidden;
}
.grid-text {
  width: 100%;
  height: 100%;
  /*height: 68%;*/
  // margin: 0% 2%;
  overflow-y: auto;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 0;
  }
}
.grid-nav {
  height: 45px;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 97.5%;
  margin-left: 1%;
  overflow: hidden;
}

.textDataStyle {
  width: 100%;
  text-align: center;
  margin-top: 12%;
}
</style>
